var bodyScrollLockOptions = {
    reserveScrollBarGap: true,
    allowTouchMove: (el) => {
        // Allow touch movement for scrollable elements and swiper navigation
        return el.closest('[data-scrollable]') !== null || 
               el.closest('.swiper-wrapper') !== null ||
               el.closest('.swiper') !== null;
    }
};

// Define a global function to load a script
window.loadScript = function (url) {
    // Check if the script already exists
    var existingScript = document.querySelector(`script[src="${url}"]`);

    if (existingScript) {
        return;
    }

    // Create a new script element
    var script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);
};


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
        cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
            cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
    /**
     * Maintain a map of listener
     * lists, keyed by event name.
     *
     * @type Object
     */
    this.listenerMap = [{}, {}];
    if (root) {
        this.root(root);
    }

    /** @type function() */
    this.handle = Delegate.prototype.handle.bind(this);

    // Cache of event listeners removed during an event cycle
    this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;

    // Remove master event listeners
    if (this.rootElement) {
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, true);
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, false);
            }
        }
    }

    // If no root or root is not
    // a dom node, then remove internal
    // root reference and exit here
    if (!root || !root.addEventListener) {
        if (this.rootElement) {
            delete this.rootElement;
        }
        return this;
    }

    /**
     * The root node at which
     * listeners are attached.
     *
     * @type Node
     */
    this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();
class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal(event, target) {
    event.preventDefault();
    event.stopPropagation();

    const trigger = target || event.target.closest('[data-action="open-modal"]');
    if (!trigger) return;

    const controlsId = trigger.getAttribute("aria-controls");
    if (!controlsId) return;

    const isLanguageSelector = trigger.getAttribute("id") === "language-selector" || controlsId === "modal-country-desktop";
    const isDesktop = responsive.matchesBreakpoint("lap_and_up");

    // Check if language selector is already open and toggle if it is
    if (isLanguageSelector) {
      const existingModal = document.getElementById(controlsId);
      if (existingModal && existingModal.getAttribute("aria-hidden") === "false") {
        // Close if already open (toggle behavior)
        this.closeModal();
        return;
      }
    }

    // Close search bar if language selector modal is being opened
    if (isLanguageSelector) {
      document.body.dispatchEvent(new CustomEvent("close:search", { bubbles: true }));
      this.pageOverlayElement = document.querySelector(".localizationOverlay");
      
      // Only disable body scroll on mobile for language selector
      if (!isDesktop) {
        bodyScrollLock.disableBodyScroll(document.body);
      }
    }

    // Don't show overlay for desktop language selector
    if (!(isLanguageSelector && isDesktop)) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
    }

    this.activeModal = document.getElementById(controlsId);
    if (!this.activeModal) return;
    this.activeModal.setAttribute("aria-hidden", "false");
    
    // For desktop language selector, don't set display style to preserve animation
    if (!(isLanguageSelector && isDesktop)) {
      this.activeModal.style.display = "block";
    }
    
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    
    // Only disable body scroll on mobile for language selector
    if (!(isLanguageSelector && isDesktop)) {
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    
    const isLanguageSelector = this.activeModal && this.activeModal.id === "modal-country-desktop";
    const isDesktop = responsive.matchesBreakpoint("lap_and_up");
    
    // Only remove overlay if it was added (not for desktop language selector)
    if (!(isLanguageSelector && isDesktop)) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
    }
    
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();

  }

  syncHeight() {
    document.documentElement.style.setProperty(
        "--window-inner-height",
        `${window.innerHeight}px`
    );
  }

  bindEvents() {
    // window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
        "click",
        '[data-action="open-product-zoom"]',
        this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
        "click",
        ".pswp__button--close",
        this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
        "breakpoint:lap_and_up",
        this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
          "pointerdown",
          "[data-move]",
          this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
          "pointerdown",
          "[data-move]",
          this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 150);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe(ev, target) {
    if (ev) ev.preventDefault();
    var images = [],
        index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          const img = item.querySelector("img");
          if (img) images.push(img);
        }
      });
      const clickedEl = target ? target.closest('.ProductSlider--Element') : null;
      if (clickedEl) {
        const clickedImg = clickedEl.querySelector('img');
        const foundIndex = clickedImg ? images.indexOf(clickedImg) : -1;
        if (foundIndex !== -1) {
          index = foundIndex;
        } else if (clickedEl.hasAttribute('data-image-position')) {
          index = parseInt(clickedEl.getAttribute('data-image-position')) || 0;
        } else {
          const ri = this.slideshow.swiperElement.realIndex;
          const el = this.slideshow.swiperElement.slides[ri]?.querySelector('.ProductSlider--Element');
          if (el && el.hasAttribute('data-image-position')) index = parseInt(el.getAttribute('data-image-position')) || 0;
        }
      } else {
        const ri = this.slideshow.swiperElement.realIndex;
        const el = this.slideshow.swiperElement.slides[ri]?.querySelector('.ProductSlider--Element');
        if (el && el.hasAttribute('data-image-position')) index = parseInt(el.getAttribute('data-image-position')) || 0;
      }
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.createPhotoSwipeInstance(
        this.createPhotoSwipeItemsFromImages(images),
        parseInt(index)
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map((image) => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      const originalWidth = parseInt(image.getAttribute("data-max-width"));
      const originalHeight = parseInt(image.getAttribute("data-max-height"));

      const aspectRatio = originalWidth / originalHeight;

      // For desktop (lap_and_up): use 100vh height and proportional width
      if (responsive.matchesBreakpoint("lap_and_up")) {
        const targetHeight = screenHeight; // 100vh
        const targetWidth = Math.floor(targetHeight * aspectRatio);

        return {
          msrc: image.currentSrc || image.src,
          w: targetWidth,
          h: targetHeight,
          initialZoomLevel: 0.65,
          src: image.dataset.originalSrc,
        };
      }

      const targetWidth = screenWidth;
      const targetHeight = screenHeight;

      return {
        msrc: image.currentSrc || image.src,
        w: targetWidth,
        h: targetHeight,
        initialZoomLevel: 1,
        src: image.dataset.originalSrc,
      };
    });
  }



  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
        photoswipeContainer,
        false,
        items,
        {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: true,
          history: false,
          closeOnVerticalDrag: true,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg"></p>',
          scaleMode: "orig",
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.35;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var allThumbnail = _this.element.querySelectorAll(
                    ".mainSwiper .ProductSliderCell--Zoom img"
                ),
                thumbnail = allThumbnail[index],
                pageYScroll =
                    window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        }
    );

    this.delegateRoot.on("slide:change", (e) => {
      this.photoSwipeInstance.goTo(e.detail)
    });

    this.photoSwipeInstance.listen(
        "destroy",
        this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
        "initialZoomIn",
        this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
        "initialZoomOut",
        this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
        "pswpTap",
        ".pswp__scroll-wrap",
        this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
        "click",
        ".pswp__button--close",
        this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--prev",
        this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--next",
        this.photoSwipeInstance.next
    );

    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
          .closest(".pswp")
          .querySelector(".pswp__ui")
          .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
          initialZoomLevel < 0.7 ? 1 : 1.33,
          point,
          333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(".RevolutionSelectbox--Content");
    this.marketSelector = this.element.classList.contains("RevolutionSelectbox--Selectors.country__selectbox");
    this.languageSelector = this.element.classList.contains("RevolutionSelectbox--Selectors.rs-language__selectbox");
    this.mainDropdownContent = this.element.querySelector(".RevolutionSelectbox--InnerContent");
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");
    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector("[name=" + this.connectedSelect + "]");
    
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(".localizationOverlay");
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("dropdownSelector")) {
      this.initSelectbox();
    } else {
      this.element.style.display = "block";
    }
  }

  bindEvents() {

    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on("click", "[data-action=toggle-selectbox]", this.toggleDropdown.bind(this));
    this.domDelegate.on("click", "[data-action=selectbox-change]", this.selectboxChange.bind(this));
    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.delegateBody.on("topbar:slideoff", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "[data-action=selectbox-submit]", this.selectboxSubmit.bind(this));
    this.domDelegate.on("keypress", "[data-action=selectbox-submit]", this.selectboxSubmit.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;

    var selEl = this.element.querySelector("#" + selectboxID);


    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }


    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;

    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );
    }
    if (event.target.dataset.selectboxid == 'language_code') {
      this.element.dispatchEvent(
        new CustomEvent("change:languageSelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );
    }
    console.log('thiscloseDropdown', this.element);
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;

    this.closeDropdown(this.element);

    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    // Submit only if there is a real form and we're not inside compare-section
    const formEl = this.selectbox?.closest('form');
    if (formEl && !this.element.closest('compare-section')) {
      formEl.submit();
    }
  }

  initSelectbox() {
    if (!this.mainDropdown) return;
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }
    // Only trap focus for popover-style selectboxes (e.g., modal/overlays)
    if (this.popover) {
      trapFocus(this.element);
    }
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {

    const closestSelectbox = target.closest('.rs-country__selectbox');
    if (closestSelectbox) {
      closestSelectbox.setAttribute('aria-expanded', 'true')
    }
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );


    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.add("is-visible");
      }
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    if (this.element.closest(".focusable.country-selector")) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';


    requestAnimationFrame(() => {
      contentElement.style.height = '';
      contentElement.style.overflow = 'hidden';
      const height = contentElement.offsetHeight;
      contentElement.style.height = '0';
      contentElement.style.visibility = 'visible';
      requestAnimationFrame(() => {
        contentElement.style.height = `${height}px`;
        // Reset overflow after animation starts to allow scrolling if needed
        setTimeout(() => {
          if (contentElement.offsetHeight > 0) {
            contentElement.style.overflow = '';
          }
        }, 300);
      });
    });


    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    if (!this.isOpen) return;

    const el             = this.element;
    const scrollable     = el.querySelector('[data-scrollable]');

    const dropdownRoot   = target.closest('.RevolutionSelectbox')
                           || el.querySelector("[aria-expanded='true']")?.parentElement;
    if (!dropdownRoot) return;

    const button  = dropdownRoot.querySelector('.RevolutionSelectbox--Button');
    const content = dropdownRoot.querySelector('.RevolutionSelectbox--Content');
  
    if (this.changeOverlay || (el.closest('#modal-country') && responsive.matchesBreakpoint('pocket'))) {
      bodyScrollLock.enableBodyScroll(scrollable, bodyScrollLockOptions);
    }
  
    dropdownRoot?.setAttribute('aria-expanded', 'false');
    button?.setAttribute('aria-expanded', 'false');
    content?.setAttribute('aria-hidden', 'true');
    
    // Animate height to 0 for smooth closing
    if (content) {
      const currentHeight = content.offsetHeight;
      content.style.height = `${currentHeight}px`;
      content.style.overflow = 'hidden';
      
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
    }
  
    const OnTransitionEnd = (e) => { 
      if (e.target === content && e.propertyName === 'height') {
        content.style.display = 'none';
        content.style.height = '';
        content.style.overflow = '';
        content.removeEventListener('transitionend', OnTransitionEnd);
      }
    };

    if (content) {
      content.addEventListener('transitionend', OnTransitionEnd);
    }

    // Fallback timeout in case transition doesn't fire
    setTimeout(() => {
      if (content) {
        content.style.display = 'none';
        content.style.height = '';
        content.style.overflow = '';
        content.removeEventListener('transitionend', OnTransitionEnd);
      }
    }, 350);
  
    if (this.keydownListener) {
      window.removeEventListener('keydown', this.keydownListener);
      this.keydownListener = null;
    }
    window.removeEventListener('click', this.onClickOutsideListener);
  
    if (this.popover) {
      this.pageOverlayElement.classList.remove('is-visible');
      document.querySelector('.header-overlay')?.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener(
        'click',
        this.onClickOutsideListener
      );
    }
  
    removeTrapFocus(this.mainDropdownContent);
    this.isOpen = false;
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;

    switch (this.breakpoint) {
      case 'lap_and_up':
        // For lap_and_up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case 'pocket':
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on(
        "click",
        selector,
        this.toggleDropdown.bind(this)
      );
    }
  }

  openDropdown(elem) {
    // Conditionally close all other dropdowns
    const faqDropdown = elem.querySelector(".info__dropdown-button.Dropdown--Button"); // FAQ dropdown
    
    if (faqDropdown) {
      document.querySelectorAll(".Dropdown").forEach((openDropdown) => {
        if (openDropdown !== elem) {
          this.closeDropdown(openDropdown);
        }
      });
    }

    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", "false");

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        DropdownContent.setAttribute("aria-hidden", "true");
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    // this.element.addEventListener("transitionend", transitionEnded);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}


new Dropdown();


class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    
    if (!element) return;
    
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings") || "{}"
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings") || "{}"
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    
    if (!element) return;
    
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.skipOverlay = false;

    // Store drawer instance on element for easy access
    this.element.drawerInstance = this;

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on("drawer:close-other", "", this.handleDrawerCloseOther.bind(this));
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

      this.delegateBody.on(
          'close:drawer',
          this.closeDrawer.bind(this)
      );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + "px";
    if (
      this.element.getAttribute("id") == "cart" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {


    }
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.skipOverlay = event.target.closest('#mobile-menu') !== null;
    this.isOpen ? this.closeDrawer(event) : this.openDrawer(event);
  }
  
  openDrawer(event) {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (this.isOpen) return;

    // Dispatch cart-drawer:open event for cart drawer
    if (this.element.getAttribute("id") === "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }

    if (this.element.getAttribute("id") == "modal-address-new" || this.element.classList.contains('account__inner-drawer')) {
      this.pageOverlayElement = this.element.parentElement.querySelector('.pageOverlay__account');
      document.querySelector('account-component-inner').style.zIndex = '20';
    }

    if (this.element.getAttribute("id") == "modal-address-new" || this.element.classList.contains('account__inner-drawer')) {
      this.pageOverlayElement = this.element.parentElement.querySelector('.pageOverlay__account');
      document.querySelector('account-component-inner').style.zIndex = '20';
    }

    this.maxHeight();

    if (this.element.getAttribute("id") == "Drawer") {
      // For mobile menu, show the correct close button
      const mobileCloseBtn = this.element.querySelector(".menu__wrapper-close");
      const desktopCloseBtn = this.element.querySelector(".Drawer--wrapper__close-menu");
      
      if (mobileCloseBtn) {
        mobileCloseBtn.style.display = "block";
      }
      if (desktopCloseBtn) {
        desktopCloseBtn.style.display = "block";
      }
      
      // Show mobile menu before animation starts
      this.element.style.display = "block";
      
      // Force reflow to ensure display:block is applied before animation
      this.element.offsetHeight;
      
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", { bubbles: true })
      );
    }

    this.element.setAttribute("aria-expanded", "true");

    if (!this.skipOverlay) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }

    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.isOpen = true;

    setTimeout(() => {
      trapFocus(this.element);
    }, 400);

    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "Drawer") {
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
    }
    this.element.setAttribute("aria-expanded", "false");

    // Add display:none optimization for mobile menu after animation completes
    if (this.element.getAttribute("id") === "Drawer") {
      this.element.addEventListener("transitionend", this.handleMobileMenuTransitionEnd.bind(this), { once: true });
    }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();

    // Close all submenus on mobile menu
    const triggerIsMobileMenu = event?.target?.closest('#mobile-menu') !== null;
    if (triggerIsMobileMenu) {
      setTimeout(() => {
        const subdrawers = this.element.querySelectorAll('[aria-expanded="true"]');
        subdrawers.forEach((drawer) => {
          drawer.setAttribute('aria-expanded', 'false');
          const activeDrawer = drawer.querySelector('.mobile__drawer.active');
          if (activeDrawer) {
            activeDrawer.classList.remove('active');
          }
           
          const scrollable = drawer.querySelector('[data-scrollable]');

          if (scrollable) {
            bodyScrollLock.enableBodyScroll(scrollable);
          }
        });
      }, 300);
    }

    // Clear form on button cancel -> account new address form
    if (this.element && this.element.getAttribute("id") === "modal-address-new") {
      document.querySelector('account-component-inner').style.zIndex = '';

      // Select all input fields inside the form
      const formInputs = this.element.querySelectorAll(".customerAccount--Inputs input.input-placeholder");
      const selectInput = this.element.querySelector("#AddressCountryNew");
      const checkboxInput = this.element.querySelector("#address_default");

      // Clear text inputs
      formInputs.forEach((input) => (input.value = ""));

      // Reset select input (fallback to first option)
      if (selectInput) selectInput.selectedIndex = 0;

      // Uncheck checkbox
      if (checkboxInput) checkboxInput.checked = false;
    }
  }

  handleDrawerCloseOther(event) {
    if (this.isOpen) {
      this.closeDrawer();
    }
  }

  handleMobileMenuTransitionEnd(event) {
    // Only apply display:none after animation completes (check for opacity or transform)
    if ((event.propertyName === "opacity" || event.propertyName === "transform") && 
        this.element.getAttribute("aria-expanded") === "false") {
      this.element.style.display = "none";
    }
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration * 2,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { opacity: "0" },
          { opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length === 0) {
          return;
        }
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: 'elementFadeIn'
        };
        const method = animations[options.type];
        if (method) {
          this[method](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}



class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    if (this.input) {
      this.input.addEventListener("input", () => { this.syncFormQuantity(); this.toggleAddButton(); });
      this.input.addEventListener("change", () => { this.syncFormQuantity(); this.toggleAddButton(); });
    }

    // Ensure disabled state reflects availability on load
    this.syncDisabledState();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const buttonEl = event.currentTarget || (event.target && event.target.closest && event.target.closest('button'));
    const isPlus = buttonEl && buttonEl.name === "plus";
    isPlus ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.syncFormQuantity();
    this.toggleAddButton();
  }


  toggleAddButton() {
    const buttons = document.querySelectorAll('.btn-atc, .ProductPage--ATC, [data-action="add-to-cart"]');
    if (!buttons || !buttons.length) return;
    const quantityEl = document.querySelector('.quantity-selector__product-quantity');
    const variantSelects = document.querySelector('variant-selects');
    const currentVariant = variantSelects && variantSelects.currentVariant ? variantSelects.currentVariant : null;
    const quantity = quantityEl && quantityEl.value ? parseInt(quantityEl.value, 10) || 1 : 1;
    const priceCents = currentVariant && currentVariant.price != null ? currentVariant.price : (this.options ? this.options['price'] : null);
    const showPrice = !!(window.variantInfo && window.variantInfo.show_price);
    const addToCartText = window.variantStrings?.addToCart || 'ADD TO CART';
    buttons.forEach((btn) => {
      btn.removeAttribute('disabled');
      btn.classList.remove('ProductCard--Sold__Out');
      const spans = btn.querySelectorAll('.ButtonTextContainer .ButtonText');
      const isSticky = !!btn.closest('.pdp-sticky');
      if (isSticky) {
        if (priceCents != null) {
          const money = Shopify.formatMoney(priceCents * quantity, window.theme.moneyFormat);
          spans.forEach((span) => {
            const p = span.querySelector('p.u-p4');
            if (p) { p.textContent = `(${money})`; }
          });
        }
      } else {
        let text = addToCartText;
        if (showPrice && priceCents != null) {
          const money = Shopify.formatMoney(priceCents * quantity, window.theme.moneyFormat);
          text = `${text} (${money})`;
        }
        if (spans && spans.length) spans.forEach((s) => { s.textContent = text; });
      }
    });
  }
  syncFormQuantity() {
    const forms = document.querySelectorAll('form[data-product-form]');
    if (!forms || !forms.length || !this.input) return;
    forms.forEach((form) => {
      const hiddenQty = form.querySelector('input[name="quantity"]');
      if (hiddenQty) hiddenQty.value = this.input.value || 1;
    });
  }

  syncDisabledState() {
    const unavailable = this.options && (this.options["available"] === "false" || this.options["available"] === false);
    const minusBtn = this.querySelector('button[name="minus"]');
    const plusBtn = this.querySelector('button[name="plus"]');
    if (unavailable) {
      if (this.input) this.input.setAttribute("disabled", "disabled");
      if (minusBtn) minusBtn.setAttribute("disabled", "disabled");
      if (plusBtn) plusBtn.setAttribute("disabled", "disabled");
    } else {
      if (this.input) this.input.removeAttribute("disabled");
      if (minusBtn) minusBtn.removeAttribute("disabled");
      if (plusBtn) plusBtn.removeAttribute("disabled");
    }
  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.Drawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    new AddToCart(this.element);

      const pairProducts = this.element.querySelector(".cart-pair-products_products");
      if (pairProducts) {
          new RevolutionSwiper(pairProducts);
          // Load Search & Discovery recommendations if configured
          this.loadCartRecommendations(pairProducts);
      }

    this.bindEvents();
    
    // Initialize cart header icons based on current cart state
    this.updateCartHeaderIcons();
  }
  
  updateCartFooterHeight() {
    // Calculate and set cart footer height as CSS custom property
    requestAnimationFrame(() => {
      const footerElement = this.element.querySelector(".cart-drawer__footer");
      if (footerElement) {
        const footerHeight = footerElement.offsetHeight;
        document.documentElement.style.setProperty(
          "--cart-drawer-footer-height",
          footerHeight + "px"
        );
      }
    });
  }
  
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".quantity-selector__current-quantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }
  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".cart-drawer__header").offsetHeight + "px"
      );
      
      // Calculate cart footer height after CSS is loaded
      this.updateCartFooterHeight();
    }
  }
  updateItemQuantity(event, target) {
    event.preventDefault();
    target
      .closest(".cart-item")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function () {
      _this.renderCart(target.getAttribute("data-id"), true);
    });
  }

  onProductAdded() {
    // Close compare drawer only (avoid closing the cart drawer if it's already open)
    try {
      const compareDrawer = document.getElementById('CompareDrawer');
      if (compareDrawer && compareDrawer.getAttribute('aria-expanded') === 'true') {
        const toggleBtn = compareDrawer.querySelector('[data-action="toggle-drawer"][data-toggle-id="CompareDrawer"]');
        if (toggleBtn) { toggleBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })); }
      }
    } catch (e) {}

    var _this = this;
    this.renderCart().then(function () {
      _this.Drawer.openDrawer();
      _this.updateCartHeaderIcons();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";

    var _this = this;
    return fetch(window.routes.localeRootUrl + "/?section_id=main-cart_drawer", {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    var number = this.tempOptions["itemCount"];
    // this.cartCount.innerHTML = "(" + number + ")";
    window.theme.cartCount = parseInt(number);
    this.updateCartHeaderIcons();
    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cart-item__info"
      );
      if (cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cart-item__info")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);
      }

      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".cart-drawer__footer"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".cart-drawer__button"
        );
        checkoutButtonParent.replaceChild(
          checkoutButtonToReplace,
          checkoutButtonParent.querySelector(".cart-drawer__button")
        );

        const footerTotalParent = this.element.querySelector(
          ".cart-drawer__footer"
        );
        const footerTotalToReplace = tempElement.querySelector(
          ".cart-footer__totals"
        );
        if (footerTotalParent && footerTotalToReplace) {
          footerTotalParent.replaceChild(
            footerTotalToReplace,
            footerTotalParent.querySelector(".cart-footer__totals")
          );
        }

        // Update shipping bar smoothly without replacing the element
        const currentShippingBar = this.element.querySelector(".cart-drawer__shipping");
        const newShippingBar = tempElement.querySelector(".cart-drawer__shipping");
        
        if (currentShippingBar && newShippingBar) {
          // Update text content smoothly
          const currentTextMobile = currentShippingBar.querySelector('.cart-drawer__shipping-text.not_desktop');
          const currentTextDesktop = currentShippingBar.querySelector('.cart-drawer__shipping-text:not(.not_desktop)');
          const newTextMobile = newShippingBar.querySelector('.cart-drawer__shipping-text.not_desktop');
          const newTextDesktop = newShippingBar.querySelector('.cart-drawer__shipping-text:not(.not_desktop)');
          
          if (currentTextMobile && newTextMobile) {
            currentTextMobile.innerHTML = newTextMobile.innerHTML;
          }
          if (currentTextDesktop && newTextDesktop) {
            currentTextDesktop.innerHTML = newTextDesktop.innerHTML;
          }
          
          // Update progress bar smoothly
          const currentProgressBar = currentShippingBar.querySelector('.cart-drawer__shipping-progress-bar');
          const newProgressBar = newShippingBar.querySelector('.cart-drawer__shipping-progress-bar');
          
          if (currentProgressBar && newProgressBar) {
            const newPercent = newProgressBar.getAttribute('data-percent') || '0';
            const cappedPercent = Math.min(parseFloat(newPercent), 100);
            const newClasses = newProgressBar.className;
            
            // Update classes for active/done state
            currentProgressBar.className = newClasses;
            currentProgressBar.setAttribute('data-percent', cappedPercent.toString());
            
            // Smoothly animate to new width
            setTimeout(() => {
              currentProgressBar.style.width = cappedPercent + '%';
            }, 50);
          }
          
        } else if (!currentShippingBar && newShippingBar) {
          // Insert shipping bar if it doesn't exist but should
          const footerParent = this.element.querySelector(".cart-drawer__footer");
          const totalsElement = footerParent.querySelector(".cart-footer__totals");
          if (totalsElement) {
            newShippingBar.style.opacity = '0';
            newShippingBar.style.transform = 'translateY(10px)';
            footerParent.insertBefore(newShippingBar, totalsElement);
            
            setTimeout(() => {
              newShippingBar.style.opacity = '1';
              newShippingBar.style.transform = 'translateY(0)';
            }, 100);
          }
        } else if (currentShippingBar && !newShippingBar) {
          // Remove shipping bar if it exists but shouldn't
          currentShippingBar.style.opacity = '0';
          currentShippingBar.style.transform = 'translateY(-10px)';
          setTimeout(() => {
            currentShippingBar.remove();
          }, 300);
        }

      } else {
        this.element
          .querySelector(".cart-drawer__footer")
          .classList.add("removing");

        const pairProducts =  this.element.querySelector(".cart-pair-products");

        if(pairProducts){
          pairProducts.classList.add("removing");
        }


        const mainPartParent = this.element.querySelector(".cart-drawer__wrapper");

        mainPartParent.innerHTML =
          tempElement.querySelector(".cart-drawer__wrapper").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren = mainPartParent.querySelector(
            "#main-cartItems"
          );
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".cart-drawer__wrapper").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".cart-drawer__wrapper"),
        this.element.querySelector(".cart-drawer__wrapper")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;

    }
    setTimeout(() => {
      var focus = _this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.Drawer.maxHeight();

        const pairProducts = _this.element.querySelector(".cart-pair-products_products");
        if (pairProducts) {
            new RevolutionSwiper(pairProducts);
            // Load Search & Discovery recommendations if configured
            _this.loadCartRecommendations(pairProducts);
        }
        
        // Update cart footer height after content changes
        _this.updateCartFooterHeight();
    }, 200);
  }

  loadCartRecommendations(pairProductsElement) {
    if (!pairProductsElement) return;
    
    const recommendationsUrl = pairProductsElement.getAttribute('data-recommendations-url');
    if (!recommendationsUrl) return;
    
    const wrapper = pairProductsElement.querySelector('#cart-recommendations-wrapper');
    if (!wrapper) return;
    
    // Show loading state
    wrapper.innerHTML = '<div class="cart-pair-loading"><p>Loading recommendations...</p></div>';
    
    // Fetch recommendations from Search & Discovery
    fetch(recommendationsUrl, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(response => response.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Extract the recommendations content
      const recommendationsContent = tempDiv.querySelector('.swiper-wrapper');
      if (recommendationsContent && recommendationsContent.children.length > 0) {
        wrapper.innerHTML = recommendationsContent.innerHTML;
        
        // Show the container and header since we have products
        const pairProductsContainer = pairProductsElement.closest('.cart-pair-products');
        if (pairProductsContainer) {
          pairProductsContainer.style.display = 'block';
        }
        
        const header = document.getElementById('cart-pair-header');
        if (header) {
          header.style.display = 'flex';
        }
        
        // Reinitialize swiper with new content
        const swiperInstance = pairProductsElement.swiper;
        if (swiperInstance) {
          swiperInstance.update();
          // Only call lazy.load if lazy module exists
          if (swiperInstance.lazy && typeof swiperInstance.lazy.load === 'function') {
            swiperInstance.lazy.load();
          }
        }
        new RevolutionAnimation(pairProductsElement);
        // Initialize add to cart functionality for new products
        new AddToCart(pairProductsElement);
      } else {
        // No recommendations found - hide entire container
        const pairProductsContainer = pairProductsElement.closest('.cart-pair-products');
        if (pairProductsContainer) {
          pairProductsContainer.style.display = 'none';
        }
        wrapper.innerHTML = '';
      }
    })
    .catch(error => {
      console.error('Error loading cart recommendations:', error);
      // Hide entire container on error
      const pairProductsContainer = pairProductsElement.closest('.cart-pair-products');
      if (pairProductsContainer) {
        pairProductsContainer.style.display = 'none';
      }
      wrapper.innerHTML = '';
    });
  }

  updateCartHeaderIcons() {
    const cartCount = window.theme.cartCount || 0;
    const fullHeaderIcon = document.querySelector('.fullHeaderIcon.cartHeaderIcon');
    const emptyHeaderIcon = document.querySelector('.emptyHeaderIcon.cartHeaderIcon');
    
    if (fullHeaderIcon && emptyHeaderIcon) {
      if (cartCount > 0) {
        fullHeaderIcon.setAttribute('aria-hidden', 'false');
        emptyHeaderIcon.setAttribute('aria-hidden', 'true');
      } else {
        fullHeaderIcon.setAttribute('aria-hidden', 'true');
        emptyHeaderIcon.setAttribute('aria-hidden', 'false');
      }
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.loader = this.element.querySelector(".itemLoader");

    this.carouselElement = this.element.querySelector(".featured-collection__swiper");


    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    if(this.carouselElement && this.options["layout"] === "grid-swiper") {

        this.carousel = new RevolutionSwiper(this.carouselElement);

      const swiperWrapper = this.element.querySelector('.swiper-wrapper.featured-collection_products');
      const visibleSlides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'))
          .filter(slide => !slide.classList.contains('hidden'));

      if (visibleSlides.length < 4 && responsive.matchesBreakpoint("lap_and_up")) {
        // Remove or reset transform

        swiperWrapper.classList.add("onlyFew");
        swiperWrapper.style.transform = "none";
      }

      else{
        swiperWrapper.classList.remove("onlyFew");
      }

    }
    this.bindEvents();

    new AddToCart(this.element);
  }

  async connectedCallback() {
    this.onLoadPage();

  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";

    this.element.addEventListener("collectionChange",  this.test.bind(this));
  }

  test(){
    const collectionId = event.detail.collectionId
      this.loader.classList.add("is-visible");

      if(this.options["layout"] === "grid-swiper"){
          this.loader.classList.add("is-visible");
          this.filterSlides(collectionId);
      }
      else{
          this.loader.classList.add("is-visible");
          const collectionId =   this.element.querySelector(".tab-link.is-active").dataset.collection;
          this.filterCollectionItems(collectionId)
      }
  }

  onLoadPage(){

    const activeElement = this.element.querySelector(".tab-link.is-active").dataset.collection;

    if(this.options["layout"] === "grid-swiper"){
        this.loader.classList.add("is-visible");
      this.filterSlides(activeElement);
    }
    else{
        this.loader.classList.add("is-visible");
      const collectionId =   this.element.querySelector(".tab-link.is-active").dataset.collection;
      this.filterCollectionItems(collectionId)
    }

  }

  filterCollectionItems(collectionId) {
    const allItems = document.querySelectorAll("[data-item-collection]");
    const activeItems = document.querySelectorAll(`[data-item-collection="${collectionId}"]`);

    allItems.forEach((el) => {
      el.style.display = [...activeItems].includes(el) ? "grid" : "none";
    });

    setTimeout(() =>{
        this.loader.classList.remove("is-visible");
    }, 500)
  }


  filterSlides(collectionId) {


    const swiperWrapper = this.element.querySelector('.swiper-wrapper.featured-collection_products');

    // 2. Hide all slides, show only matching
    const allSlides = swiperWrapper.querySelectorAll('.swiper-slide');

    allSlides.forEach(slide => {
      const shouldShow = slide.dataset.itemCollection === collectionId;

      slide.classList.remove("swiper-slide-active");
      slide.classList.remove("swiper-slide-next");
      if(shouldShow) {
        slide.classList.remove('hidden');
      }

      else{
        slide.classList.add('hidden');
      }

    });

    const visibleSlides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'))
        .filter(slide => !slide.classList.contains('hidden'));

    if (visibleSlides.length < 4 && responsive.matchesBreakpoint("lap_and_up")) {
      // Remove or reset transform

      swiperWrapper.classList.add("onlyFew");
      swiperWrapper.style.transform = "none";
    }

    else{
      swiperWrapper.classList.remove("onlyFew");
    }

      if (this.carousel  && this.carousel .swiperElement?.destroy) {
          this.carousel.swiperElement.destroy(true, true);
      }

      // Delay reflow and re-initialize
      requestAnimationFrame(() => {

          this.carousel  = new RevolutionSwiper(this.carouselElement);
      });

      setTimeout(() =>{
          this.loader.classList.remove("is-visible");
      }, 500)
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}

customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.delegateElement = new Delegate(this.element);

    // Apply lazy loading for sections beyond index 2
    if (this.options.sectionIndex > 2) {
      this.applyLazyLoading();
    }

    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.updateSlideCounter();
      this.bindEvents();
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  bindEvents() {
    // Bind observer event
    this.onImagesReady = this.createObserver.bind(this);
    this.element.addEventListener("swiper:slide-changed", this.onImagesReady);

    if (this.carousel.swiperElement) {
      this.carousel.swiperElement.on("reachBeginning", () => {
       if (this.carousel.swiperElement.params.rewind && this.carousel.swiperElement.params.autoplay) {
          this.carousel.swiperElement.autoplay.stop();
        }
      });

      this.carousel.swiperElement.on("slideChange", () => {
        this.updateSlideCounter();
      });
    }
  }

  updateSlideCounter() {
    const current = this.element.querySelector(".swiper-custom-counter .current");
    if (!this.carousel?.swiperElement || !current) return;

    const swiper = this.carousel.swiperElement;
    const currentIndex = swiper.params.loop ? swiper.realIndex : swiper.activeIndex;

    current.textContent = currentIndex + 1;
  }

  disconnectedCallback() {
    if (this.resizeListener) {
      this.resizeListener.removeResizeListener();
    }
  }

  applyLazyLoading() {
    const images = this.element.querySelectorAll('img[loading="eager"]');
    images.forEach(img => {
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
    });
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.5 });
    this.observer.observe(this.element);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }

  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();
    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(cellElement.querySelectorAll(".image__element")).slice(0, 2);
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) return;

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal =
      breakpoint === "pocket" || breakpoint === "phone" || breakpoint === "tablet"
        ? imageContainers[0]
        : imageContainers.length === 2
        ? imageContainers[1]
        : imageContainers[0];

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") return;

    if (imageToReveal.dataset.src) {
      // Replace the image URL with a higher quality version.
      imageToReveal.src = imageToReveal.dataset.src.replace("{width}x", "width=2600");
      imageToReveal.dataset.loadedImage = "true";
    }
  }
}

customElements.define("banner-hero", Banner);

function rafThrottle(fn){
  let rafId = null, lastArgs = null;
  const runner = () => { rafId = null; fn.apply(null, lastArgs); };
  return function(...args){
    lastArgs = args;
    if (rafId === null) rafId = requestAnimationFrame(runner);
  };
}


class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings") || "{}");

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    selectBoxes.forEach((item) => new RevolutionSelectbox(item));

    if (this.options.sticky && this.element.parentElement) {
      this.element.parentElement.classList.add("header--Sticky");
    }

    // GPU layer – smiri rendering na iOS-u
    const wrapper = this.element.querySelector(".header--Wrapper");
    if (wrapper) wrapper.style.transform = "translateZ(0)";
    this.element.style.willChange = "transform";

    this.bindEvents();
    this.updateVisibleHeight(); // inicijalno
    this.observeMenuToggle();
    this.removeSrcsetFromMenuImages();
  }

  bindEvents() {
    // VAŽNO: nema scroll listenera – nepotreban je i uzrokuje reflow
    window.addEventListener("resize", this.updateVisibleHeight.bind(this), { passive: true });
    window.addEventListener("announcement-height-changed", this.handleAnnouncementHeightChange.bind(this));

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on("mouseenter", "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on("focusin", "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on("mouseleave", "[aria-submenu], #header", this.closeMenu.bind(this), true);
    this.delegateElement.on("mouseenter", "[aria-singlemenu]", this.closeMenu.bind(this), true);
    this.delegateElement.on("focusin", "[aria-singleMenu], .mainLinks", this.closeMenu.bind(this), true);
    this.delegateElement.on("mouseenter", ".menuDropdown__item", this.showSubmenu.bind(this), true);
    this.delegateElement.on(
      "mouseenter",
      ".menuDropdown__list .hoverLinks, .menuDropdown__submenu-list .hoverLinks",
      this.previewImageEnter.bind(this),
      true
    );
    this.delegateElement.on("mouseleave", ".menuDropdown__submenu-list .hoverLinks", this.previewImageLeave.bind(this), true);
  }

  // Minimalno održavanje vlastitih varijabli (bez scrolla)
  updateVisibleHeight = rafThrottle(() => {
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
    const visibleHeight = Math.max(this.element.offsetHeight, 0);
    document.documentElement.style.setProperty("--header-dynamic-height", `${visibleHeight}px`);
    document.documentElement.style.setProperty("--header-height-fixed", `${visibleHeight}px`);
  });

  handleAnnouncementHeightChange(event) {
    
    this.updateVisibleHeight();
  }

  previewImageEnter(_event, target) {
    const previewSrc = target.getAttribute("data-preview-src");
    if (!previewSrc) return;

    const dropdown = target.closest(".menuDropdown");
    const previewImage = dropdown?.querySelector(".desktop-menu__img .image__element");
    if (!previewImage) return;

    previewImage.dataset.originalSrc = previewImage.getAttribute("src");
    previewImage.setAttribute("src", previewSrc);
  }

  previewImageLeave(_event, target) {
    const dropdown = target.closest(".menuDropdown");
    const previewImage = dropdown?.querySelector(".desktop-menu__img .image__element");
    if (!previewImage || !previewImage.dataset.originalSrc) return;
    previewImage.setAttribute("src", previewImage.dataset.originalSrc);
  }

  removeSrcsetFromMenuImages() {
    const images = this.element.querySelectorAll(".desktop-menu__img .image__element");
    images.forEach((img) => {
      const srcset = img.getAttribute("srcset");
      const src = img.getAttribute("src");
      if (srcset) {
        img.setAttribute("data-original-srcset", srcset);
        img.setAttribute("original-src", src);
        img.removeAttribute("srcset");
      }
    });
  }

  showSubmenu(_event, target) {
    const wrapper = target.closest(".menuDropdown__links");
    if (!wrapper) return;

    const dropdown = wrapper.closest(".menuDropdown");
    this.hideAllSubmenus(dropdown);

    const index = target.dataset.submenuIndex;
    if (!index) return;

    const submenu = dropdown.querySelector(`.menuDropdown__submenu[data-submenu-index="${index}"]`);
    if (!submenu || submenu.querySelectorAll("a").length === 0) return;

    wrapper.querySelectorAll(".menuDropdown__item").forEach((item) => {
      this.setAriaExpanded(item, item === target);
    });

    wrapper.querySelectorAll(".menuDropdown__submenu").forEach((item) => {
      item.hidden = item.dataset.submenuIndex !== index;
    });
  }

  hideAllSubmenus(target) {
    target.querySelectorAll(".menuDropdown__submenu").forEach((submenu) => (submenu.hidden = true));
    target.querySelectorAll(".menuDropdown__item").forEach((item) => this.setAriaExpanded(item, false));
  }

  setAriaExpanded(element, state) {
    if (element) element.setAttribute("aria-expanded", state ? "true" : "false");
  }

  openMenu(event, target) {
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
    if (event.type === "mouseenter" && target !== event.target) return;
  
    // reset preview slike
    this.element.querySelectorAll(".desktop-menu__img img").forEach((img) => {
      const originalSrc = img.getAttribute("original-src");
      if (originalSrc) img.setAttribute("src", originalSrc);
    });
  
    // aria
    this.setAriaExpanded(target, true);
    Array.from(target.parentElement.children).forEach((sibling) => {
      if (sibling !== target) this.setAriaExpanded(sibling, false);
    });
  
    // otvaranje dropdowna s animacijom
    const dropdown = this.getDropdownFromItem(target);
    this.animateOpenDropdown(dropdown);
  
    // lock body scroll kad je menu otvoren
    const scrollable = this.element.querySelector("[data-scrollable]");
    if (scrollable) bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
  
    const wrapper = this.element.querySelector(".header--Wrapper");
    if (wrapper) wrapper.classList.add("menu-opened");
  }
  
  closeMenu(event, target) {
    // isti hover-guard kao i ranije
    if (event.type === "mouseleave") {
      if (target !== event.target) return;
      const toEl = event.relatedTarget;
      if (toEl && this.element.contains(toEl)) return;
    }
  
    const expandedItems = this.element.querySelectorAll('[aria-expanded="true"]');
    if (!expandedItems.length) return;
  
    expandedItems.forEach((item) => this.setAriaExpanded(item, false));
  
    // odključaј body scroll
    bodyScrollLock.clearAllBodyScrollLocks();
  
    // vrati preview slike
    this.element.querySelectorAll(".desktop-menu__img img").forEach((img) => {
      const originalSrc = img.getAttribute("original-src");
      if (originalSrc) img.setAttribute("src", originalSrc);
    });
  
    // sakrij sve submenije
    const dropdown = this.element.querySelector(".menuDropdown[aria-submenu]");
    if (dropdown) this.hideAllSubmenus(dropdown);
  
    // zatvori SVE otvorene dropdownove animirano
    this.element.querySelectorAll(".menuDropdown.is-open").forEach((d) => this.animateCloseDropdown(d));
  
    const wrapper = this.element.querySelector(".header--Wrapper");
    if (wrapper) wrapper.classList.remove("menu-opened");
  }
  
  



getDropdownFromItem(item){
  return item?.querySelector?.(".menuDropdown") || null;
}

animateOpenDropdown(drop){
  if (!drop) return;
  // zatvori sve ostale otvorene (ako prelaziš s itema na item)
  this.element.querySelectorAll(".menuDropdown.is-open").forEach(d => {
    if (d !== drop) this.animateCloseDropdown(d);
  });

  // faza 1
  drop.classList.add("is-open");
  // force reflow da bi transition znao start state
  // eslint-disable-next-line no-unused-expressions
  drop.offsetHeight;
  // faza 2 – pokreni animaciju
  requestAnimationFrame(() => drop.classList.add("is-visible"));
}

animateCloseDropdown(drop){
  if (!drop || !drop.classList.contains("is-open")) return;
  // pokreni izlaz (slide-out)
  drop.classList.remove("is-visible");
  const onEnd = (e) => {
    if (e.propertyName !== "opacity") return; // čekamo završetak
    drop.removeEventListener("transitionend", onEnd);
    drop.classList.remove("is-open"); // display:none nakon izlaza
  };
  drop.addEventListener("transitionend", onEnd, { once: true });
}




  observeMenuToggle() {
    const menuWrapper = document.querySelector("main-menu-dropdown .menu__wrapper");
    const toggleButton = document.getElementById("mobile-menu");
    if (!menuWrapper || !toggleButton) return;

    const iconClose = toggleButton.querySelector(".Svg--window_close");
    const iconBars = toggleButton.querySelector(".Svg--bars");

    const updateIcons = () => {
      const isExpanded = menuWrapper.getAttribute("aria-expanded") === "true";
      iconClose.style.display = isExpanded ? "block" : "none";
      iconBars.style.display = isExpanded ? "none" : "block";
    };

    updateIcons();

    const observer = new MutationObserver(updateIcons);
    observer.observe(menuWrapper, { attributes: true, attributeFilter: ["aria-expanded"] });
  }
}

customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const allDrawer = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawer.forEach((item) => {
      new Drawer(item);
    });

    this.setUpMobileWrapperClass();
    this.bindEvents();
  }

  bindEvents() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateElement.on("mouseover", '[data-action="toggle-subdrawer"]', (event, target) => {
        this.toggleNextElement(event, target);
      });
      this.delegateElement.on("mouseover", '[data-special="hover-subdrawer"]', (event, target) => {
        this.toggleNextElement(event, target);
      });
      this.delegateElement.on("mouseover", ".menu__top-link-static", (event, target) => {
        this.toggleElement(event, target);
      });
    }

    if (!responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateElement.on("click", '[data-action="toggle-subdrawer"]', this.toggleNextElement.bind(this));
    }

    this.delegateElement.on("click", '[data-action="toggle-prev-subdrawer"]', this.togglePreviousElement.bind(this));
    this.delegateBody.on("sidebar-drawer:close", this.toggleElement.bind(this), true);
    
    // Close mobile menu when cart drawer opens
    document.addEventListener("cart-drawer:open", this.closeMobileMenu.bind(this));
  }

  setUpMobileWrapperClass(wrapperSelector = ".menu__wrapper") {
    const wrapper = wrapperSelector === ".menu__wrapper"
      ? this.element.querySelector(wrapperSelector)
      : wrapperSelector;

    if (!wrapper) return;

    if (responsive.matchesBreakpoint("pocket")) {
      wrapper.classList.add("Drawer--Top");
    }
  }

  toggleElement(event, target) {
    document.dispatchEvent(new CustomEvent("selectors:close"));
    const levelElement = target.closest(".Drawer--wrapper");
    let toggleLinks;

    const closeExpandedSubdrawer = (selector) => {
      const subdrawer = this.querySelector(`${selector}[aria-expanded="true"]`);
      if (subdrawer) {
        subdrawer.setAttribute("aria-expanded", "false");
      }
    };

    if (!levelElement) {
      closeExpandedSubdrawer(".menu__third");
      closeExpandedSubdrawer(".menu__second");
      toggleLinks = document.querySelectorAll('.menu__top-container-submenu[aria-expanded="true"]');
    } else if (levelElement.classList.contains("menu__second")) {
      closeExpandedSubdrawer(".menu__third");
      toggleLinks = document.querySelectorAll('.menu__second .menu__top-container-submenu[aria-expanded="true"]');
    } else if (levelElement.classList.contains("menu__first")) {
      toggleLinks = document.querySelectorAll('.menu__top-container-submenu[aria-expanded="true"]');
      closeExpandedSubdrawer(".menu__third");
      closeExpandedSubdrawer(".menu__second");
    }

    this.toggleLinks(toggleLinks, target);
  }

  toggleLinks(toggleLinks, target) {
    if (!toggleLinks || !toggleLinks.length) return;

    toggleLinks.forEach((link) => {
      if (link !== target) {
        link.setAttribute("aria-expanded", "false");
      }
    });
  }

  toggleNextElement(event, target) {
    event.preventDefault();

    const nextEl = target.getAttribute("data-toggle-id");
    const subdrawer = this.element.querySelector("#" + nextEl);
    this.setUpMobileWrapperClass(subdrawer);

    // Show submenu before animation starts
    subdrawer.style.display = "block";
    
    // Force reflow to ensure display:block is applied before animation
    subdrawer.offsetHeight;

    const animateContent = subdrawer.querySelector(".mobile__drawer");
    if (animateContent) {
      animateContent.classList.add("active");
    }

    if (responsive.matchesBreakpoint("lap_and_up")) {
      if (event.target.classList.contains("menu__top-container-submenu")) {
        event.target.setAttribute("aria-expanded", "false");
      } else {
        event.target.closest(".menu__top-container-submenu").setAttribute("aria-expanded", "true");
      }

      const otherLinks = event.target.closest(".menu__wrapper").querySelectorAll('.menu__top-container-submenu[aria-expanded="true"]');
      this.toggleLinks(otherLinks, target);

      setTimeout(() => {
        if (!target.dataset.third) {
          const drawers = this.element.querySelectorAll("[data-subdrawer]");
          drawers.forEach((item) => {
            item.setAttribute("aria-expanded", "false");
            // Add transition end listener for submenus
            this.addSubmenuTransitionListener(item);
          });
        } else {
          const thirdDrawers = this.element.querySelectorAll(".menu__third");
          thirdDrawers.forEach((item) => {
            item.setAttribute("aria-expanded", "false");
            // Add transition end listener for submenus
            this.addSubmenuTransitionListener(item);
          });
        }

        subdrawer.setAttribute("aria-expanded", "true");
        const focus = subdrawer.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }, 15);
    } else {
      setTimeout(() => {
        subdrawer.setAttribute("aria-expanded", "true");
        const focus = subdrawer.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }, 15);
    }
  }

  togglePreviousElement(event, target) {
    event.preventDefault();

    this.subdrawer = target.closest(".menu__wrapper");
    this.subdrawer.setAttribute("aria-expanded", "false");

    const animateContent = this.subdrawer.querySelector(".mobile__drawer");
    if (animateContent) {
      animateContent.classList.remove("active");
    }

    const focus = this.subdrawer.querySelector("[data-scrollable]");
    bodyScrollLock.enableBodyScroll(focus);

    // Add transition end listener for submenu to set display:none after animation
    this.addSubmenuTransitionListener(this.subdrawer);
  }

  translateTransitionEnded(event) {
    if (event.propertyName === "transform") {
      this.subdrawer.removeEventListener("transitionend", this.transitionEndedListener);
    }
  }

  addSubmenuTransitionListener(submenu) {
    // Add transition end listener for submenus to set display:none after animation
    submenu.addEventListener('transitionend', (event) => {
      if ((event.propertyName === 'opacity' || event.propertyName === 'transform') && 
          submenu.getAttribute('aria-expanded') === 'false') {
        submenu.style.display = 'none';
      }
    }, { once: true });
  }

  closeMobileMenu() {
    const mobileMenuDrawer = this.element.querySelector('#Drawer');
    
    if (mobileMenuDrawer && mobileMenuDrawer.getAttribute('aria-expanded') === 'true') {
      // Close all submenus first
      const openSubmenus = this.element.querySelectorAll('[data-subdrawer][aria-expanded="true"]');
      openSubmenus.forEach(submenu => {
        submenu.setAttribute('aria-expanded', 'false');
        // Add transition end listener for submenus
        this.addSubmenuTransitionListener(submenu);
      });
      
      // Close all expanded menu items
      const expandedItems = this.element.querySelectorAll('.menu__top-container-submenu[aria-expanded="true"]');
      expandedItems.forEach(item => {
        item.setAttribute('aria-expanded', 'false');
      });
      
      // Find the drawer instance and close it
      const drawerInstance = mobileMenuDrawer.drawerInstance;
      if (drawerInstance && drawerInstance.isOpen) {
        drawerInstance.closeDrawer();
      }
    }
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}

new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    if (!this.element) return;
    
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings") || "{}"
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      const swiperSlide = this.element.closest(".swiper-slide");
      if (
        this.element.dataset.position == 0 ||
        (swiperSlide && swiperSlide.classList.contains("swiper-slide-active")) ||
        (swiperSlide && swiperSlide.classList.contains("swiper-slide-duplicate-active"))
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";


    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: this.options["viewport"] ? "none" : "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,


      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  bindCustomControls() {
    this.stateElements = this.element.querySelectorAll("[data-action='toggle-state']");
    this.soundElements = this.element.querySelectorAll("[data-action='toggle-sound']");

    if (!this.stateElements.length || !this.soundElements.length) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () => {
        this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause();
    });

    this.delegateElement.on("click", "[data-action='toggle-sound']", () => {
        this.videoPlayer.muted() ? this.videoPlayer.muted(false) : this.videoPlayer.muted(true);
    });

    this.videoPlayer.on("play", () => {
        this.stateElements.forEach(el => el.setAttribute("aria-label", "playing"));
    });

    this.videoPlayer.on("pause", () => {
        this.stateElements.forEach(el => el.setAttribute("aria-label", "paused"));
    });

    this.videoPlayer.on("volumechange", () => {
        this.soundElements.forEach(el => el.setAttribute("aria-label", this.videoPlayer.muted() ? "muted" : "unmuted"));
    });
}


  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}

customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.footer = this.element;
    this.footerVisibleClass = 'footer--visible';
    this.initClearButton();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == 'phone' || breakpoint == 'tablet') {
      // this.dropdown = new Dropdown(this.element);
    }

    this.setFooterHeight();
    window.addEventListener('resize', this.setFooterHeight.bind(this));

    this.initObserver();
  }

   setFooterHeight() {
    setTimeout(() => {
      const footerWrapper = document.querySelector('.mainfooter__wrapper');
      if (footerWrapper) {
        document.documentElement.style.setProperty(
          '--footer-height',
          `${footerWrapper.offsetHeight}px`
        );
      }
    }, 150);
  }

  initClearButton() {
    const clearBtn = this.element.querySelector(
      '.footer__newsletter-clear-button'
    );
    const subscribeBtn = this.element.querySelector(
      '.footer__newsletter-subscribe-button'
    );
    const newsletterInputsWrapper = this.element.querySelector(
      '.footer__newsletter-inputs'
    );
    if (!clearBtn) return;

    clearBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = this.element.querySelector('#footer-form');
      if (!form) return;

      form.reset();

      newsletterInputsWrapper.classList.remove(
        'footer__newsletter-inputs--error'
      );

      clearBtn.classList.add('hidden');
      if (subscribeBtn) subscribeBtn.classList.remove('hidden');

      const errorMsg = this.element.querySelector(
        '.footer__newsletter-email-error'
      );
      if (errorMsg) errorMsg.remove();
    });
  }

  initObserver() {
    const logoEl = this.element.querySelector('.footer__logo-outer');
    if (!logoEl || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            logoEl.classList.add('visible');
          } else {
            logoEl.classList.remove('visible');
          }
        });
      },
      {
        root: null,
        threshold: 0.2,
      }
    );

    requestAnimationFrame(() => {
      observer.observe(this.footer);
    });
  }
}
customElements.define('footer-component', FooterComponent);



class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    
    // Core elements
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".ProductSlider--Thumbnails");
    this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky");
    this.mainAtc = this.element.querySelector(".product-cta__block");
    
    // Feature elements
    const pdfDrawerElement = this.element.querySelector('#pdf-drawer');
    this.drawer = pdfDrawerElement ? new Drawer(pdfDrawerElement) : null;
    this.uspOptions = this.element.querySelector(".product-usps");
    // Initialize PDF and product type features
    this.initializeDynamicContent();
    
    // State
    this._shareBusy = false;
    this._cleanupFunctions = [];
  }

  async connectedCallback() {
    this.initialize();
    this.bindEvents();
    this.initializeFeatures();
  }

  disconnectedCallback() {
    this._cleanupFunctions.forEach(cleanup => cleanup());
    this._cleanupFunctions = [];
  }

  // INITIALIZATION METHODS
  initialize() {
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.initializeCarousel();
    this.initializeComponents();
  }

  initializeCarousel() {
    if (this.options['slides_number'] <= 1) return;

    const showThumbs = this.options['show_thumbnails'] && responsive.matchesBreakpoint("lap_and_up");
    this.carousel = showThumbs 
      ? new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs)
      : new RevolutionSwiper(this.carouselElement);
  }

  initializeComponents() {
    // Local pickup
    const localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) new Drawer(localPickup);

    // Add to cart
    new AddToCart(this.element);

    // Image zoom
    if (this.options["enable_zoom"] && this.carousel) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    // Select boxes
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    selectBoxes.forEach(item => new RevolutionSelectbox(item));

    // Initial variant image
    if (this.options['variant_image_id'] && this.options['show_variant_image_on_load']) {
      this.updateImage();
    }

    this.setupThumbsHeightSync();
  }

  initializeDynamicContent() {
    const dynamicContentElement = this.element.querySelector(".pdf-content-placeholder");
    const productTypes = this.element.querySelector(".product-types");
    const pairProducts = this.element.querySelector(".pdp-pdf-drawer__pair-products");
    const title = this.element.querySelector(".pair-with-title");

    if (dynamicContentElement) this.generateContentFromHtml(dynamicContentElement);
    if (productTypes) this.getProductTypes(productTypes);
    if (pairProducts && title) this.getPairProducts(pairProducts, title);
  }

  initializeFeatures() {
    this.setupDescriptionClamping();
    this.getFileSize();
    this.handleNotifyMeButton();
  }

  // EVENT BINDING
  bindEvents() {
    // Variant changes
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    // User interactions
    this.domDelegate.on("click", '[data-action="download-pdf"]', this.downloadPdf.bind(this));
    this.domDelegate.on("click", ".share-btn", this.copyLink.bind(this));
    this.domDelegate.on("click", '[data-action="scroll-to"]', this.scrollToSection.bind(this));
    this.domDelegate.on("click", ".product-toggle-button", this.toggleDescription.bind(this));

    // Sticky ATC
    if (this.stickyAtcWrapper) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
    }

    // Browser navigation
    window.addEventListener('popstate', () => location.reload());
  }

  // USER INTERACTION METHODS
  scrollToSection(ev, target) {
    ev.preventDefault();
    const destinationId = target.getAttribute("href");
    const destination = document.querySelector(destinationId);
    
    if (destination) {
      destination.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

async downloadPdf(ev) {
  ev.preventDefault();

  const element = this.element.querySelector("#pdf-content");

   // Save CSS variables BEFORE cloning
  const htmlStyles = getComputedStyle(document.documentElement);
  const savedVars = {
    announcementFixed: htmlStyles.getPropertyValue('--announcement-height-fixed'),
    announcementDynamic: htmlStyles.getPropertyValue('--announcement-dynamic-height'),
    headerOffset: htmlStyles.getPropertyValue('--header-offset')
  };

  const fileName = element?.dataset.product;
  if (!element) {
    console.error("PDF content element not found.");
    return;
  }
  try {
    // Load scripts dynamically if not already loaded
    if (!window.html2canvas) {
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js");
    }
    if (!window.jspdf) {
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");
    }
    // Wait for scripts to be available
    await this.waitForScripts();
    
    // Use scrollWidth to get the actual content width
    const drawerWidth = element.scrollWidth;
 
    // Create a clone for safer processing
    const clonedElement = element.cloneNode(true);
    
    // Remove problematic elements from the clone
    const elementsToRemove = clonedElement.querySelectorAll(
      'script, video, iframe, audio, [data-swiper-settings], custom-element, product-component, header-component, announcement-bar, .announcement-bar, search-bar, .header, .search-bar, form, [data-action="download-pdf"]'
    );
    elementsToRemove.forEach(el => el.remove());

    // Remove images with ProductCard__Image--secondary class
    const secondaryImages = clonedElement.querySelectorAll('.ProductCard__Image--secondary');
    secondaryImages.forEach(img => img.remove());

    // Remove fade classes from elements
    const fadeElements = clonedElement.querySelectorAll('.content-fade, .fade-right, .fade-left');
    fadeElements.forEach(el => {
      el.classList.remove('content-fade', 'fade-right', 'fade-left');
    });
    
    // Make all nested scrollable elements expand to show their full content
    const allElements = clonedElement.querySelectorAll('*');
    allElements.forEach(el => {
      const computedStyle = window.getComputedStyle(el);
      if (computedStyle.overflow === 'scroll' ||
          computedStyle.overflow === 'auto' ||
          computedStyle.overflowY === 'scroll' ||
          computedStyle.overflowY === 'auto') {
        el.style.overflow = 'visible';
        el.style.overflowY = 'visible';
        el.style.overflowX = 'visible';
        el.style.height = 'auto';
        el.style.maxHeight = 'none';
      }
    });
    
    // Temporarily add clone to body (hidden) to get accurate container sizes
    clonedElement.style.position = 'absolute';
    clonedElement.style.left = '-9999px';
    clonedElement.style.bottom = '-9999px';
    clonedElement.style.width = `${drawerWidth}px`;
    clonedElement.style.minWidth = `${drawerWidth}px`;
    clonedElement.style.overflow = 'visible';
    clonedElement.style.overflowX = 'visible';
    clonedElement.style.height = 'auto';
    clonedElement.style.maxHeight = 'none';

    document.body.appendChild(clonedElement);

    
    // Fix .product-types .SelectboxImage containers first
    const selectboxLinks = clonedElement.querySelectorAll('.product-types .SelectboxImage');
    selectboxLinks.forEach(link => {
      const linkWidth = link.offsetWidth;
      
      link.style.display = 'block';
      link.style.overflow = 'visible';
      
      // Also fix the AspectRatio container inside - make it square based on link width
      const aspectRatioContainer = link.querySelector('.AspectRatio');
      if (aspectRatioContainer) {
        aspectRatioContainer.style.width = `${linkWidth}px`;
        aspectRatioContainer.style.height = `${linkWidth}px`; // Force square
        aspectRatioContainer.style.overflow = 'visible';
      }
    });
    
    // Fix all images to fit within their containers AFTER adding to DOM
    const allImages = clonedElement.querySelectorAll('img');
    
    // Process images and create scaled versions for product-type images
    const imageProcessingPromises = Array.from(allImages).map(async (img) => {
      // Get the parent container's computed width
      const parent = img.parentElement;
      let parentWidth = parent ? parent.offsetWidth : drawerWidth;
      
      // If parent has 0 width, traverse up to find a parent with width
      if (parentWidth === 0) {
        let ancestor = parent;
        while (ancestor && parentWidth === 0) {
          ancestor = ancestor.parentElement;
          parentWidth = ancestor ? ancestor.offsetWidth : drawerWidth;
        }
        // Fallback to drawer width if still 0
        if (parentWidth === 0) {
          parentWidth = drawerWidth;
        }
      }
      
      // Check if this image is inside .product-types
      const isProductTypeImage = img.closest('.product-types');
      
      // Remove lazy loading attributes
      img.removeAttribute('loading');
      img.removeAttribute('data-src');
      
      // Remove any transforms or positioning
      img.style.transform = 'none';
      img.style.position = 'relative';
      
      if (isProductTypeImage && img.naturalWidth > 0 && img.naturalHeight > 0) {
        // For product-types images, get the SelectboxImage link dimensions
        const selectboxLink = img.closest('.SelectboxImage');
        const containerSize = selectboxLink ? selectboxLink.offsetWidth : parentWidth;
        
        // Create a canvas to scale down the image
        const canvas = document.createElement('canvas');
        canvas.width = containerSize;
        canvas.height = containerSize;
        const ctx = canvas.getContext('2d');
        
        // Draw the image scaled down to fit in the square
        ctx.drawImage(img, 0, 0, containerSize, containerSize);
        
        // Replace the image src with the scaled version
        const scaledDataUrl = canvas.toDataURL('image/png');
        img.src = scaledDataUrl;
        
        // Set dimensions
        img.setAttribute('width', containerSize);
        img.setAttribute('height', containerSize);
        img.style.width = `${containerSize}px`;
        img.style.height = `${containerSize}px`;
        img.style.maxWidth = `${containerSize}px`;
        img.style.maxHeight = `${containerSize}px`;
        img.style.objectFit = 'contain';
        img.style.display = 'block';
        
        console.log('ProductType Image scaled and replaced:', containerSize, 'x', containerSize);
      } else if (!isProductTypeImage) {
        // For other images, use the existing logic
        img.style.maxWidth = '100%';
        img.style.width = '100%';
        img.style.height = 'auto';
        img.style.objectFit = 'contain';
        img.style.display = 'block';
        
        // Remove explicit width/height attributes
        img.removeAttribute('width');
        img.removeAttribute('height');
      }
      
      console.log('Image:', img.src.substring(0, 50), 'Natural:', img.naturalWidth, 'x', img.naturalHeight, 'Parent:', parentWidth, 'Final:', img.offsetWidth, 'x', img.offsetHeight, 'ProductType:', !!isProductTypeImage);
    });
    
    await Promise.all(imageProcessingPromises);
    
    // Fix image containers that might have overflow hidden
    const imageContainers = clonedElement.querySelectorAll('div, figure, picture');
    imageContainers.forEach(container => {
      if (container.querySelector('img')) {
        container.style.overflow = 'visible';
        // Ensure container doesn't constrain the image incorrectly
        const style = window.getComputedStyle(container);
        if (style.width && style.width !== 'auto') {
          container.style.width = style.width; // Keep existing width
        }
      }
    });
    
    // Wait another moment for image adjustments to take effect
    await new Promise(resolve => setTimeout(resolve, 300));
    
    // Get the full expanded dimensions from the clone
    const fullHeight = clonedElement.scrollHeight;
    const fullWidth = clonedElement.scrollWidth;
    
    const canvas = await html2canvas(clonedElement, {
      scale: 2,
      useCORS: true,
      scrollY: 0,
      scrollX: 0,
      allowTaint: true,
      backgroundColor: '#ffffff',
      width: fullWidth,
      height: fullHeight,
      windowWidth: fullWidth,
      imageTimeout: 0,
      logging: false
    });
    
    // Remove the temporary clone
    document.body.removeChild(clonedElement);
    
    const imgData = canvas.toDataURL("image/png");
    
    // Use the ACTUAL canvas dimensions divided by scale
    const pdfWidth = canvas.width / 2;
    const pdfHeight = canvas.height / 2;

    
    // Create PDF with the correct dimensions
    const pdf = new window.jspdf.jsPDF({
      orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
      unit: "px",
      format: [pdfWidth, pdfHeight]
    });
    
    // Add the image at the correct size
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, '', 'FAST');
    pdf.save(`${fileName}.pdf`);
  } catch (err) {
    console.error("Failed to generate PDF:", err);
  } finally {
    // Restore CSS variables AFTER everything
    document.documentElement.style.setProperty('--announcement-height-fixed', savedVars.announcementFixed);
    document.documentElement.style.setProperty('--announcement-dynamic-height', savedVars.announcementDynamic);
    document.documentElement.style.setProperty('--header-offset', savedVars.headerOffset);
  }
}

  // Helper method to wait for scripts to be available
  waitForScripts() {
    return new Promise((resolve) => {
      const checkScripts = () => {
        if (window.html2canvas && window.jspdf) {
          resolve();
        } else {
          setTimeout(checkScripts, 100);
        }
      };
      checkScripts();
    });
  }

  copyLink(ev, target) {
    ev.preventDefault();
    if (this._shareBusy) return;
    
    this._shareBusy = true;
    const currentLocation = window.location.href;

    const announce = (message) => {
      const previous = target.innerHTML;
      target.innerHTML = message;
      setTimeout(() => {
        target.innerHTML = previous;
        this._shareBusy = false;
      }, 1500);
    };

    this.attemptShare(currentLocation, announce);
  }

  async attemptShare(url, callback) {
    // Try native share first
    if (navigator.share) {
      try {
        await navigator.share({ url });
        callback('Shared');
        return;
      } catch (err) {
        // User cancelled or error, fall through to clipboard
      }
    }

    // Fallback to clipboard
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        callback('Copied');
      } else {
        this.fallbackCopyToClipboard(url, callback);
      }
    } catch (err) {
      this.fallbackCopyToClipboard(url, callback);
    }
  }

  fallbackCopyToClipboard(text, callback) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    
    document.body.appendChild(textarea);
    textarea.select();
    
    try {
      document.execCommand('copy');
      callback('Copied');
    } catch (err) {
      this._shareBusy = false;
    } finally {
      document.body.removeChild(textarea);
    }
  }

  // DESCRIPTION METHODS
  toggleDescription() {
    const desc = this.element.querySelector(".product-description");
    const btn = this.element.querySelector(".product-toggle-button");

    if (!desc || !btn) return;

    desc.classList.toggle("expanded");
    const isExpanded = desc.classList.contains("expanded");
    
    this.updateToggleButtonState(isExpanded);
  }

  updateToggleButtonState(isExpanded) {
    const moreBtn = this.element.querySelector(".more");
    const lessBtn = this.element.querySelector(".less");

    if (isExpanded) {
      lessBtn?.classList.add("show");
      moreBtn?.classList.remove("show");
    } else {
      moreBtn?.classList.add("show");
      lessBtn?.classList.remove("show");
    }
  }

  setupDescriptionClamping() {
    const desc = this.element.querySelector(".product-description");
    const btn = this.element.querySelector(".product-toggle-button");

    if (!desc || !btn) return;

    const updateToggleVisibility = () => {
      const isExpanded = desc.classList.contains("expanded");
      
      if (isExpanded) {
        btn.style.display = "flex";
        this.updateToggleButtonState(true);
        return;
      }

      const shouldShow = this.isContentClamped(desc);
      btn.style.display = shouldShow ? "flex" : "none";
      
      if (shouldShow) this.updateToggleButtonState(false);
    };

    // Initial setup
    requestAnimationFrame(updateToggleVisibility);
    
    // Event listeners
    window.addEventListener('load', updateToggleVisibility, { once: true });
    
    const resizeHandler = () => updateToggleVisibility();
    window.addEventListener('resize', resizeHandler);
    
    this._cleanupFunctions.push(() => {
      window.removeEventListener('resize', resizeHandler);
    });

    // ResizeObserver for better performance
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(updateToggleVisibility);
      resizeObserver.observe(desc);
      
      this._cleanupFunctions.push(() => {
        resizeObserver.disconnect();
      });
    }
  }

  isContentClamped(element) {
    return element.scrollHeight > element.clientHeight + 1;
  }

  // STICKY ATC METHODS
  showStickyAtc() {
    const options = { root: null, threshold: 0 };
    let mainVisible = false;
    let footerVisible = false;

    const footerEl = document.querySelector('footer');
    const isDebugMode = window.location.search.includes('debug=sticky');

    const updateSticky = this.debounce(() => {
      const shouldHide = mainVisible || footerVisible;
      this.stickyAtcWrapper.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      
      if (isDebugMode) {
        console.log('🏷️ Sticky ATC:', { mainVisible, footerVisible, shouldHide });
      }
    }, 50);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.target === this.mainAtc) {
          mainVisible = entry.isIntersecting;
        } else if (entry.target === footerEl) {
          footerVisible = entry.isIntersecting;
        }
      });
      updateSticky();
    }, options);

    if (this.mainAtc) observer.observe(this.mainAtc);
    if (footerEl) observer.observe(footerEl);

    this._cleanupFunctions.push(() => observer.disconnect());
  }

  // PRODUCT DATA METHODS
  getPairProducts(content, title) {
    const slides = this.element.querySelectorAll(".pdp-pair-slide");
    const titleFrom = this.element.querySelector(".pdp-pair-products__header h2");

    if (title && titleFrom) {
      title.innerHTML = titleFrom.innerHTML;
    }
    
    if (slides.length > 0) {
      slides.forEach(slide => {
        content.innerHTML += slide.innerHTML;
      });
    }
  }

  getProductTypes(el) {
    const data = this.element.querySelector(".connected-products__products");
    if (data) {
      el.innerHTML = data.innerHTML;
    }
  }

  generateContentFromHtml(el) {
    const dataEl = this.element.querySelector(".pdp-group-dropdown");
    if (dataEl) {
      const data = dataEl.firstElementChild;
      const content = data?.querySelector(".Dropdown--Content");
      if (content) {
        el.innerHTML = content.innerHTML;
      }
    }
  }

  async getFileSize() {
    const link = document.querySelector('.download-link');
    if (!link) return;

    const url = link.getAttribute('href');
    const sizeEl = link.querySelector('.file-num');

    try {
      const response = await fetch(url, {
        method: 'HEAD'
      });
      
      const contentLength = response.headers.get('content-length');
      if (contentLength) {
        const sizeMB = (contentLength / (1024 * 1024)).toFixed(2);
        sizeEl.innerHTML = `${sizeMB} <span class="u-p4 size">MB</span>`;
      } else {
        sizeEl.innerHTML = '';
      }
    } catch (err) {
      sizeEl.innerHTML = '';
    }
  }

  // CAROUSEL METHODS
  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    if (!imageEl) return;

    const slideElement = imageEl.closest('.swiper-slide');
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);
    
    this.carousel?.selectCell(realIndex);
  }

  setupThumbsHeightSync() {
    if (!this.carouselElementThumbs) return;

    const syncHeight = () => this.syncThumbsHeight();
    
    setTimeout(syncHeight, 0);
    
    const resizeHandler = responsive.addResizeListener(this, syncHeight);
    this._cleanupFunctions.push(() => {
      if (resizeHandler?.removeResizeListener) {
        resizeHandler.removeResizeListener();
      }
    });

    if (this.carousel?.swiperElement) {
      try {
        const events = ["resize", "imagesReady", "slideChangeTransitionEnd"];
        events.forEach(event => {
          this.carousel.swiperElement.on(event, syncHeight);
        });

        this._cleanupFunctions.push(() => {
          events.forEach(event => {
            try {
              this.carousel.swiperElement.off(event, syncHeight);
            } catch (e) {}
          });
        });
      } catch (e) {}
    }
  }

  syncThumbsHeight() {
    if (!this.carouselElement || !this.carouselElementThumbs) return;
    
    if (!responsive.matchesBreakpoint("lap_and_up")) {
      this.carouselElementThumbs.style.height = "";
      return;
    }

    const mainHeight = this.carouselElement.offsetHeight || 0;
    if (mainHeight > 0) {
      this.carouselElementThumbs.style.height = mainHeight + "px";
    }

    // Update thumbs swiper
    try {
      this.carousel?.thumbSwiper?.update();
    } catch (e) {}
  }

  handleNotifyMeButton() {
    const notifyPopup = document.querySelector("notify-me-popup");
    
    if (!notifyPopup) {
      const notifyButtons = this.element.querySelectorAll('[data-action="notify-open"]');
      notifyButtons.forEach(button => {
        button.disabled = true;
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.6';
      });
    }
  }

  // UTILITY METHODS
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define("product-component", ProductElement);


class VariantSelects extends HTMLElement {
  // Configuration constants
  static SELECTORS = {
    VARIANT_SELECTS: '.VariantSelect',
    ATC_BUTTONS: '.ProductCard--instantATC, .AddToCartAjax, .btn-atc:not(.product-module__product-atc-notify):not(.product-module__product-atc-disabled)',
    NOTIFY_BUTTONS: '.product-module__product-atc-notify',
    DISABLED_BUTTONS: '.product-module__product-atc-disabled',
    PRODUCT_COMPONENT: 'product-component',
    PRODUCT_FORMS: 'form[data-productid]',
    RADIO_CHECKED: 'input[type="radio"]:checked'
  };

  static BUTTON_STATES = {
    AVAILABLE: 'available',
    NOTIFY_ME: 'notify_me', 
    OUT_OF_STOCK: 'out_of_stock'
  };

  constructor() {
    super();
    this.element = this;
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    
    // Debug mode
    this.isDebugMode = window.location.search.includes('debug=variants');
    
    // Performance cache
    this._cache = {};
    this._debounceTimeout = null;
    
    // Price elements
    this.priceElements = this.initializePriceElements();
    
    // Initialize
    this.bindEvents();
    this.initializeVariants();
  }

  // INITIALIZATION
  initializePriceElements() {
    return {
      regular: document.querySelector("product-component .product-info__price--regular span"),
      compare: document.querySelector("product-component .product-info__price--compare"),
      wrapper: document.querySelector(".product-info__price")
    };
  }

  initializeVariants() {
    const variantData = this.getVariantData();

    console.log('variant data', variantData);
    if (variantData?.length > 0) {
      this.currentVariant = variantData.find(variant => variant.available) || variantData[0];
    }

    if (this.checkIfAllSelected()) {
      this.onVariantChange();
    }

    // Enable all radio buttons initially
    this.enableAllRadioButtons();
    this.updateButtonStates();
  }

  enableAllRadioButtons() {
    const allRadios = this.element.querySelectorAll("input[type='radio']");
    allRadios.forEach(radio => {
      radio.disabled = false;
      radio.removeAttribute('disabled');
    });
  }

  // EVENT BINDING
  bindEvents() {
    // Select elements (legacy compatibility)
    const selectboxes = this.element.querySelectorAll("select");
    selectboxes.forEach(item => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
    
    // Radio inputs (new box selector)
    const radioInputs = this.element.querySelectorAll("input[type='radio']");
    radioInputs.forEach(input => {
      input.addEventListener("change", this.onRadioVariantChange.bind(this));
    });
    
    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
  }

  clickAtc(event) {
    event.preventDefault();
    const mainAtcButton = document.querySelector('.product-info__actions .product__atc-button, .product-cta__block .btn-atc');
    mainAtcButton?.click();
  }

  // VARIANT CHANGE HANDLERS
  onRadioVariantChange(event) {
    const radio = event.target;
    const optionName = radio.getAttribute('data-option-name');
    const value = radio.value;
    
    if (this.isDebugMode) {
      console.log('🔄 Radio variant change:', optionName, '=', value);
    }
    
    // Update corresponding select element
    const selectElement = this.element.querySelector(`select[data-name="${optionName}"]`);
    if (selectElement) {
      selectElement.value = value;
    }
    
    if (this.checkIfAllSelected()) {
      this.updateCurrentVariant();
      this.updateVariantInput();
      this.debouncedVariantChange();
    }
  }

  onVariantChange() {
    if (this.checkIfAllSelected()) {
      this.updateCurrentVariant();
      this.updateVariantStatuses();
      this.updateMedia();
      this.updateURL();
      this.updatePrices();
      this.updateVariantInput();
      this.updateButtonStates();
      this.updateLowestPrice();
    }
  }

  debouncedVariantChange() {
    clearTimeout(this._debounceTimeout);
    this._debounceTimeout = setTimeout(() => {
      this.onVariantChange();
    }, 150);
  }

  // VARIANT LOGIC
  checkIfAllSelected() {
    const variantSelects = this.getVariantSelects();
    if (variantSelects.length > 0) {
      return Array.from(variantSelects).every(select => 
        select.querySelector(VariantSelects.SELECTORS.RADIO_CHECKED)
      );
    }
    
    // Fallback for legacy dropdowns
    const variants_content = this.element.querySelectorAll('.RevolutionSelectbox--Content');
    return Array.from(variants_content).every(content => 
      Array.from(content.children).some(child => child.hasAttribute('selected'))
    );
  }

  updateCurrentVariant() {
    this.updateSelectedOptions();
    this.findMatchingVariant();
  }

  updateSelectedOptions() {
    const variantSelects = this.getVariantSelects();
    if (variantSelects.length > 0) {
      this.selectedOptions = Array.from(variantSelects, select => {
        const checkedRadio = select.querySelector(VariantSelects.SELECTORS.RADIO_CHECKED);
        return checkedRadio?.value || null;
      }).filter(Boolean);
    } else {
      this.selectedOptions = Array.from(this.querySelectorAll("select"), select => select.value);
    }
  }

  findMatchingVariant() {
    const variantData = this.getVariantData();
    if (!variantData?.length || !this.selectedOptions?.length) return;
    
    console.log('this.currentVariant ovde', this.currentVariant)
    this.currentVariant = variantData.find(variant => {
      return variant.options?.every((option, index) => 
        this.selectedOptions[index] === option
      );
    });
    
    // Fallback to first available or first variant
    if (!this.currentVariant) {
      this.currentVariant = variantData.find(variant => variant.available) || variantData[0];
    }
    
    if (this.isDebugMode) {
      console.log('Current variant:', this.currentVariant?.id, 'Available:', this.currentVariant?.available);
    }
  }

  // BUTTON STATE MANAGEMENT
  updateButtonStates() {
    if (!this.currentVariant) return;

    const notifyMeEnabled = this.isNotifyMeEnabled();
    const state = this.determineButtonState(notifyMeEnabled);
    
    if (this.isDebugMode) {
      console.log('🔘 Button state:', state, 'Notify enabled:', notifyMeEnabled);
    }

    switch (state) {
      case VariantSelects.BUTTON_STATES.AVAILABLE:
        this.showAtcButtons();
        this.hideNotifyButtons();
        this.hideDisabledButtons();
        break;
      case VariantSelects.BUTTON_STATES.NOTIFY_ME:
        this.hideAtcButtons();
        this.showNotifyButtons();
        this.hideDisabledButtons();
        break;
      case VariantSelects.BUTTON_STATES.OUT_OF_STOCK:
        this.hideAtcButtons();
        this.hideNotifyButtons();
        this.showDisabledButtons();
        break;
    }
  }

  determineButtonState(notifyMeEnabled) {
    if (this.currentVariant.available) {
      return VariantSelects.BUTTON_STATES.AVAILABLE;
    } else if (notifyMeEnabled) {
      return VariantSelects.BUTTON_STATES.NOTIFY_ME;
    } else {
      return VariantSelects.BUTTON_STATES.OUT_OF_STOCK;
    }
  }

  isNotifyMeEnabled() {
    return !!document.querySelector("notify-me-popup");
  }

  // BUTTON VISIBILITY METHODS
  showAtcButtons() {
    const buttons = this.getAtcButtons();
    const addToCartText = window.variantStrings?.addToCart || 'ADD TO CART';
    
    buttons.forEach(button => {
      button.style.display = 'block';
      button.classList.remove('variant-button-hidden');
      button.disabled = false;
      
      // Update button text
      const buttonTexts = button.querySelectorAll('.ButtonText');
      buttonTexts.forEach(txt => txt.textContent = addToCartText);
      
      // Set correct action
      button.dataset.action = button.closest('.pdp-sticky') ? 'click-atc' : 'add-to-cart';
    });
  }

  hideAtcButtons() {
    const buttons = this.getAtcButtons();
    buttons.forEach(button => {
      button.style.display = 'none';
      button.classList.add('variant-button-hidden');
    });
  }

  showNotifyButtons() {
    let buttons = this.getNotifyButtons();
    
    // Create notify buttons if they don't exist
    if (buttons.length === 0) {
      this.createNotifyButtons();
      buttons = this.getNotifyButtons(true); // Refresh cache
    }
    
    const notifyText = window.variantStrings?.notifyMe || 'NOTIFY ME';
    
    buttons.forEach(button => {
      button.style.display = 'block';
      button.classList.remove('variant-button-hidden');
      button.disabled = false;
      
      const buttonTexts = button.querySelectorAll('.ButtonText');
      buttonTexts.forEach(txt => txt.textContent = notifyText);
    });
  }

  hideNotifyButtons() {
    const buttons = this.getNotifyButtons();
    buttons.forEach(button => {
      button.style.display = 'none';
      button.classList.add('variant-button-hidden');
    });
  }

  showDisabledButtons() {
    let buttons = this.getDisabledButtons();
    
    // Create disabled buttons if they don't exist
    if (buttons.length === 0) {
      this.createDisabledButtons();
      buttons = this.getDisabledButtons(true); // Refresh cache
    }
    
    const outOfStockText = window.variantStrings?.outOfStock || 'OUT OF STOCK';
    
    buttons.forEach(button => {
      button.style.display = 'block';
      button.classList.remove('variant-button-hidden');
      button.disabled = true;
      
      const buttonTexts = button.querySelectorAll('.ButtonText');
      buttonTexts.forEach(txt => txt.textContent = outOfStockText);
    });
  }

  hideDisabledButtons() {
    const buttons = this.getDisabledButtons();
    buttons.forEach(button => {
      button.style.display = 'none';
      button.classList.add('variant-button-hidden');
    });
  }

  // BUTTON CREATION
  createNotifyButtons() {
    const atcButtons = this.getAtcButtons();
    atcButtons.forEach(atcButton => {
      this.createButtonFromTemplate(atcButton, 'notify');
    });
    this.invalidateCache();
  }

  createDisabledButtons() {
    const atcButtons = this.getAtcButtons();
    atcButtons.forEach(atcButton => {
      this.createButtonFromTemplate(atcButton, 'disabled');
    });
    this.invalidateCache();
  }

  createButtonFromTemplate(templateButton, type) {
    // Check if button already exists
    const existingButton = templateButton.parentElement.querySelector(
      type === 'notify' ? '.product-module__product-atc-notify' : '.product-module__product-atc-disabled'
    );
    
    if (existingButton) return existingButton;
    
    const newButton = templateButton.cloneNode(true);
    const className = type === 'notify' ? 'product-module__product-atc-notify' : 'product-module__product-atc-disabled';
    const action = type === 'notify' ? 'notify-open' : '';
    
    // Update classes and attributes
    newButton.className = `Button Button--Secondary ${className} btn-atc animated-btn-wrapper`;
    if (action) newButton.setAttribute('data-action', action);
    newButton.setAttribute('type', 'button');
    newButton.style.display = 'none';
    newButton.classList.add('variant-button-hidden');
    
    // Insert after the template button
    templateButton.parentElement.insertBefore(newButton, templateButton.nextSibling);
    
    return newButton;
  }

  // UPDATE METHODS
  updateVariantStatuses() {
    const variantData = this.getVariantData();
    if (!variantData?.length) return;

    const selectContainers = this.element.querySelectorAll(".VariantSelect");
    if (!selectContainers.length) return;

    // Get select elements
    const selectElements = Array.from(selectContainers)
      .map(container => container.querySelector("select"))
      .filter(Boolean);

    if (!selectElements.length) return;

    // Update availability for each select
    selectElements.forEach((select, index) => {
      if (index === 0) return; // Skip first select
      
      const availableOptions = this.getAvailableOptionsForSelect(variantData, selectElements, index);
      this.setSelectAvailability(select, availableOptions);
    });
  }

  getAvailableOptionsForSelect(variantData, selectElements, selectIndex) {
    const previousValues = selectElements.slice(0, selectIndex).map(select => select.value);
    
    return variantData
      .filter(variant => {
        if (!variant.available) return false;
        return previousValues.every((value, i) => variant[`option${i + 1}`] === value);
      })
      .map(variant => variant[`option${selectIndex + 1}`]);
  }

  setSelectAvailability(selectElement, availableOptions) {
    const variantSelect = selectElement.closest('.VariantSelect');
    if (!variantSelect) return;

    const radioInputs = variantSelect.querySelectorAll('input[type="radio"]');
    
    radioInputs.forEach(input => {
      const container = input.closest('.Selectbox');
      const label = container.querySelector('label');
      const isAvailable = availableOptions.includes(input.value);
      
      // Always keep clickable
      input.disabled = false;
      container.classList.remove('variant-unavailable', 'variant-unavailable-visual');
      
      // Remove existing indicators
      const existingSup = label.querySelector('sup');
      if (existingSup) existingSup.remove();
      
      if (!isAvailable) {
        // Add visual indicator for unavailable options
        const notifyMeSup = document.createElement('sup');
        notifyMeSup.className = 'u-p4';
        notifyMeSup.textContent = window.variantStrings?.notifyMe || 'NOTIFY ME';
        label.appendChild(notifyMeSup);
        container.classList.add('variant-unavailable-visual');
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media?.id) return;

    this.element.dispatchEvent(new CustomEvent("variant:changed", {
      bubbles: true,
      detail: { new_image: this.currentVariant.featured_media.id }
    }));
  }

  updateURL() {
    if (!this.currentVariant) return;
    
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    window.history.replaceState({}, "", url);
  }

  updatePrices() {
    if (!this.currentVariant) return;

    // Update price elements
    if (this.priceElements.regular) {
      this.priceElements.regular.innerHTML = Shopify.formatMoney(
        this.currentVariant.price,
        window.theme.moneyFormat
      );
    }

    // Handle compare at price
    if (this.currentVariant.compare_at_price) {
      if (this.priceElements.compare) {
        this.priceElements.compare.innerHTML = Shopify.formatMoney(
          this.currentVariant.compare_at_price,
          window.theme.moneyFormat
        );
      } else {
        this.createCompareAtPrice();
      }
    } else if (this.priceElements.compare) {
      this.priceElements.compare.innerHTML = "";
    }

    // Dispatch price change event
    this.element.dispatchEvent(new CustomEvent("price:change", {
      bubbles: true,
      detail: {
        eventName: "variant",
        price_raw: this.currentVariant.price,
        compare_at_price: this.currentVariant.compare_at_price
      }
    }));
  }

  createCompareAtPrice() {
    if (!this.priceElements.wrapper || !this.currentVariant.compare_at_price) return;
    
    const compareDiv = document.createElement("span");
    compareDiv.className = "u-s2 product-info__price--compare";
    compareDiv.textContent = Shopify.formatMoney(
      this.currentVariant.compare_at_price,
      window.theme.moneyFormat
    );
    
    this.priceElements.wrapper.appendChild(compareDiv);
    this.priceElements.compare = compareDiv;
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const productForms = document.querySelectorAll(`form[data-productid="${this.productID}"]`);
    
    productForms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
      input.dataset.id = this.currentVariant.id;
      input.dataset.sku = this.currentVariant.sku || '';
      
      if (this.currentVariant.sku) {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateLowestPrice() {
    const allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInputs = document.querySelectorAll(".product-info__price--lowest span");
    const lowestPriceDivs = document.querySelectorAll(".product-info__price--lowest");

    allMetaVariants.forEach(meta => {
      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        const lowestPrice = meta.getAttribute("meta-data");
        
        lowestPriceInputs.forEach(input => {
          input.innerHTML = Shopify.formatMoney(lowestPrice, window.theme.moneyFormat);
        });

        lowestPriceDivs.forEach(item => {
          item.style.display = lowestPrice == 0 ? "none" : "flex";
        });
      }
    });
  }

  // DATA METHODS
  getVariantData() {
    if (this.variantData) return this.variantData;
    
    try {
      const jsonScript = this.querySelector('[type="application/json"]');
      if (!jsonScript?.textContent) return [];
      
      this.variantData = JSON.parse(jsonScript.textContent);
      return this.variantData;
    } catch (error) {
      console.error('Error parsing variant data:', error);
      return [];
    }
  }

  // CACHE METHODS
  getVariantSelects() {
    if (!this._cache.variantSelects) {
      this._cache.variantSelects = this.element.querySelectorAll(VariantSelects.SELECTORS.VARIANT_SELECTS);
    }
    return this._cache.variantSelects;
  }

  getAtcButtons(refresh = false) {
    if (!this._cache.atcButtons || refresh) {
      const productComponent = this.element.closest(VariantSelects.SELECTORS.PRODUCT_COMPONENT);
      this._cache.atcButtons = productComponent ? 
        productComponent.querySelectorAll(VariantSelects.SELECTORS.ATC_BUTTONS) : [];
    }
    return this._cache.atcButtons;
  }

  getNotifyButtons(refresh = false) {
    if (!this._cache.notifyButtons || refresh) {
      const productComponent = this.element.closest(VariantSelects.SELECTORS.PRODUCT_COMPONENT);
      this._cache.notifyButtons = productComponent ? 
        productComponent.querySelectorAll(VariantSelects.SELECTORS.NOTIFY_BUTTONS) : [];
    }
    return this._cache.notifyButtons;
  }

  getDisabledButtons(refresh = false) {
    if (!this._cache.disabledButtons || refresh) {
      const productComponent = this.element.closest(VariantSelects.SELECTORS.PRODUCT_COMPONENT);
      this._cache.disabledButtons = productComponent ? 
        productComponent.querySelectorAll(VariantSelects.SELECTORS.DISABLED_BUTTONS) : [];
    }
    return this._cache.disabledButtons;
  }

  invalidateCache() {
    this._cache = {};
  }

  // PUBLIC API
  refresh() {
    if (this.checkIfAllSelected()) {
      this.onVariantChange();
    }
    return this;
  }

  forceButtonUpdate() {
    this.invalidateCache();
    if (this.currentVariant) {
      this.updateButtonStates();
    }
    return this;
  }
}

customElements.define("variant-selects", VariantSelects);


class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    if (!this.element) return;
    
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputSelector = '[name="q"]';

    this.searchResultsElement = this.element.querySelector(".search-bar__results-wrapper");
    this.transitionElement = this.element.querySelector(".search-bar__inner");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.searchBarWrapper = this.element.querySelector(".search-bar__input-wrapper");
    this.options = JSON.parse(this.element.getAttribute("data-settings") || "{}");

    const inputEl = this.element.querySelector(this.searchInputSelector);
    if (inputEl) {
      document.documentElement.style.setProperty("--search-header-height", `${inputEl.offsetHeight + 48}px`);
    }

    // Save initial layout for reset purposes
    this.initialSearchLayout = this.searchResultsElement ? this.searchResultsElement.cloneNode(true) : null;

    new AddToCart(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on("click", '[data-action="open-search"]', this.openSearch.bind(this));
    this.delegateElement.on("click", '[data-action="clear-input"]', this.resetSearch.bind(this));
    this.delegateElement.on("click", '[data-action="close-search"]', this.closeSearch.bind(this));
    this.delegateElement.on("click", ".searchTab", this.handleTabClick.bind(this));
    this.delegateElement.on("input", this.searchInputSelector, this._onInputListener);
    this.delegateElement.on("click", '[data-action="search-string"]', this.onInput.bind(this));
    this.delegateElement.on("keypress", '[data-action="search-string"]', this.onInput.bind(this));
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  // Handles tab switching for search resource types
  handleTabClick(event, target) {
    const selectedTab = target.dataset.tab;
    this.element.querySelectorAll(".searchTab").forEach((btn) => btn.classList.remove("is-active"));
    target.classList.add("is-active");

    this.element.querySelectorAll("[data-tab-content]").forEach((el) => {
      el.style.display = el.dataset.tabContent === selectedTab ? "block" : "none";
    });
  }

  // Utility function to debounce calls (e.g. for search input)
  debounce(fn, delay) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  // Opens the search drawer/modal
  openSearch(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.dispatchEvent(new CustomEvent("drawer:close-other", { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    this.element.setAttribute("aria-hidden", false);
    this.pageOverlayElement.classList.add("is-visible");
    bodyScrollLock.disableBodyScroll(this.searchResultsElement, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.transitionElement.style.height = "unset";
    this.searchResultsElement.style.flex = "unset";

    setTimeout(() => {
      const input = this.element.querySelector(this.searchInputSelector);
      if (input) input.focus();
    }, 200);

    this.isOpen = true;

    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  // Closes the search drawer/modal
  closeSearch(event) {
    if (event) event.preventDefault();
    if (!this.isOpen) return;

    // Remove overlay click listener if present
    if (this.pageOverlayElement && this.closeListener) {
      this.pageOverlayElement.removeEventListener("click", this.closeListener);
      this.closeListener = null;
    }

    // Reset content/state so next open starts clean
    this.resetSearch();

    document.body.classList.remove("scrollLock");
    bodyScrollLock.enableBodyScroll(this.searchResultsElement, bodyScrollLockOptions);
    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);

    this.element.addEventListener("transitionend", this.handleSearchCloseBinder);
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    this.isOpen = false;
  }

  // Handles cleanup after transition ends when closing search
  handleSearchClose(e) {
    if (e.propertyName === "opacity") {
      this.element.removeEventListener("transitionend", this.handleSearchCloseBinder);
    }
  }

  // Handles user input and fetches predictive search results
  async onInput(event) {
    this.lastInputValue = event.target.dataset.value || event.target.value;
    if (this.lastInputValue === "") {
      this.resetSearch();
      return;
    }

    this.searchResultsElement.style.opacity = 0;

    const input = this.element.querySelector(this.searchInputSelector);
    if (event.target.dataset.value && input) {
      input.value = this.lastInputValue;
      input.setAttribute("value", this.lastInputValue);
    }

    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`);
      if (!response.ok) throw new Error(response.status);

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");
      const resultsMarkup = html.querySelector("#shopify-section-search-predictive").innerHTML;

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.searchResultsElement.style.opacity = 1;
      this.transitionElement.style.height = "100%";
      this.searchResultsElement.style.flex = "1";
      this.element.querySelectorAll('[data-tab-content]').forEach((el) => {
        el.style.display = el.dataset.tabContent === "products" ? "block" : "none";
      });
      this.element.querySelectorAll('[data-tab-controls] .searchTab').forEach((tab) => {
        tab.classList.remove("is-active");
        if (tab.dataset.tab === "products") tab.classList.add("is-active");
      });

      this.highlightSuggestedQueries(this.lastInputValue);
      this.applyHighlightToSuggestedCollections(this.lastInputValue);
    } catch (error) {
      if (error?.code === 20) return;
      console.error("Search fetch error:", error);
    }
  }

  // Resets the search state and restores the initial layout
  resetSearch() {
    const clonedLayout = this.initialSearchLayout.cloneNode(true);
    this.searchResultsElement.innerHTML = clonedLayout.innerHTML;

    const input = this.element.querySelector(this.searchInputSelector);
    if (input) {
      input.value = "";
      input.removeAttribute("value");
      input.dataset.action = "prevent-enter";
    }

    this.searchResultsElement.style.opacity = 0;

    this.transitionElement.style.height = "unset";
    this.searchResultsElement.style.flex = "unset";

    this.element.querySelectorAll('[data-tab-content]').forEach((el) => {
      el.style.display = el.dataset.tabContent === "products" ? "block" : "none";
    });
    this.element.querySelectorAll('.searchTab').forEach((tab) => {
      tab.classList.remove("is-active");
      if (tab.dataset.tab === "products") tab.classList.add("is-active");
    });
  }

  // Highlights part of suggested query text that matches the input
  highlightSuggestedQueries(term) {
    const suggestions = this.element.querySelectorAll(".search__query");
    if (!term) return;

    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedTerm, 'i');

    suggestions.forEach((el) => {
      const value = el.dataset.value?.trim();
      if (!value) return;

      const match = value.match(regex);
      if (match) {
        const index = match.index;
        const matchedText = match[0];

        const before = value.slice(0, index);
        const after = value.slice(index + matchedText.length);
        el.innerHTML = `${before}<mark>${matchedText}</mark>${after}`;
      }
    });
  }

  // Applies highlight color to specific collection links based on their handle
  applyHighlightToSuggestedCollections() {
    const coloredHandlesRaw = this.element.dataset.coloredHandles || "";
    const highlightColor = this.element.dataset.highlightColor;
    if (!coloredHandlesRaw || !highlightColor) return;

    const handles = coloredHandlesRaw
      .split(",")
      .map((h) => h.trim().toLowerCase())
      .filter(Boolean);

    this.element.querySelectorAll(".search-collection-item").forEach((el) => {
      const handle = el.dataset.collectionHandle?.toLowerCase();
      if (handles.includes(handle)) {
        el.style.color = highlightColor;
      }
    });
  }
}

customElements.define("search-bar", SearchBar);

class TermsCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  async connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element.querySelector('.swiper');

    const rev = new RevolutionSwiper(this.swiperElement);
  }
}
customElements.define('terms-carousel', TermsCarousel);



class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  async connectedCallback() {
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.element.querySelectorAll('.RevolutionSelectbox').forEach(box => new RevolutionSelectbox(box));

    this.bindEvents();
    this.bindDirectEvents();
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on('keydown', '[data-action="select-language"]', this.selectLanguage.bind(this));
    
    // Close language selector when other elements open
    this.delegateBody.on("close:search", this.closeLanguageSelector.bind(this));
    this.delegateBody.on("drawer:close-other", this.closeLanguageSelector.bind(this));
    this.delegateBody.on("menu:close", this.closeLanguageSelector.bind(this));
    this.delegateBody.on("menu:open", this.closeLanguageSelector.bind(this));
    this.delegateBody.on("cart-drawer:open", this.closeLanguageSelector.bind(this));
    this.delegateBody.on("sidebar-drawer:open", this.closeLanguageSelector.bind(this));
    
    // Prevent ANY click inside language selector from closing it
    this.delegateBody.on("click", "#modal-country-desktop", this.preventLanguageSelectorClose.bind(this));
    
    // Close when any button with data-action is clicked (except language selector related)
    this.delegateBody.on("click", "[data-action]:not([data-action*='open-modal'])", this.handleActionClick.bind(this));
    
    // Handle click outside for desktop (since we don't use overlay)
    this.delegateBody.on("click", "", this.handleClickOutside.bind(this));
    
    // Handle ESC key to close language selector
    this.delegateBody.on("keydown", "", this.handleKeyDown.bind(this));
  }

  bindDirectEvents() {
    // Add direct event listener with high priority to capture events early
    this.documentClickHandler = (event) => {
      const languageModal = document.getElementById('modal-country-desktop');
      if (languageModal && languageModal.getAttribute('aria-hidden') === 'false') {
        // Check if click is inside the language selector modal
        if (languageModal.contains(event.target)) {
          const clickedElement = event.target;
          const dataAction = clickedElement.getAttribute('data-action') || clickedElement.closest('[data-action]')?.getAttribute('data-action');

          
          // Don't stop propagation - let selectbox work normally
          // Just mark that language selector should not close
          event._languageSelectorHandled = true;
          return;
        }
      }
    };
    
    // Add listener with capture phase to get events first
    document.addEventListener('click', this.documentClickHandler, true);
  }

  disconnectedCallback() {
    // Clean up event listener when element is removed
    if (this.documentClickHandler) {
      document.removeEventListener('click', this.documentClickHandler, true);
    }
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  preventLanguageSelectorClose(event) {
    // Stop all propagation to prevent any other event handlers from closing the language selector
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Mark this event as handled to prevent closing
    event._languageSelectorHandled = true;
  }

  handleActionClick(event) {
    // Don't handle if event was already handled by language selector prevention
    if (event._languageSelectorHandled) {
      return;
    }
    
    const languageModal = document.getElementById('modal-country-desktop');
    
    // If language selector is open and click is inside it, don't close
    if (languageModal && languageModal.getAttribute('aria-hidden') === 'false') {
      const isClickInsideModal = languageModal.contains(event.target);
      if (isClickInsideModal) {
        return; // Don't close
      }
      // Close if click is outside
      this.closeLanguageSelector(event);
    }
  }

  handleClickOutside(event) {
    // Don't handle if event was already handled by language selector prevention
    if (event._languageSelectorHandled) return;
    
    // Only handle click outside on desktop and when language selector is open
    if (!responsive.matchesBreakpoint("lap_and_up")) return;
    
    const languageModal = document.getElementById('modal-country-desktop');
    if (!languageModal || languageModal.getAttribute('aria-hidden') !== 'false') return;
    
    // Check if click is outside the language selector and its trigger
    const isClickInsideModal = languageModal.contains(event.target);
    const isClickOnTrigger = event.target.closest('#language-selector') || event.target.closest('[aria-controls="modal-country-desktop"]');
    
    // Don't close if clicking inside the modal (including dropdowns)
    if (!isClickInsideModal && !isClickOnTrigger) {
      this.closeLanguageSelector(event);
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      const languageModal = document.getElementById('modal-country-desktop');
      if (languageModal && languageModal.getAttribute('aria-hidden') === 'false') {
        this.closeLanguageSelector();
      }
    }
  }

  closeLanguageSelector(event = null) {
    // If this is called from an event and the event is inside the language selector, don't close
    if (event && event.target) {
      const languageModal = document.getElementById('modal-country-desktop');
      if (languageModal && languageModal.contains(event.target)) {
        return;
      }
    }
    
    const languageModal = document.getElementById('modal-country-desktop');
    if (languageModal && languageModal.getAttribute('aria-hidden') === 'false') {
      // Find the popup instance and close it
      const popup = document.body.querySelector('.Popup[aria-hidden="false"]');
      if (popup && popup.id === 'modal-country-desktop') {
        popup.setAttribute('aria-hidden', 'true');
        
        // On desktop, don't touch style attribute to preserve animation, on mobile remove style attribute
        if (!responsive.matchesBreakpoint("lap_and_up")) {
          popup.removeAttribute('style');
        }
        
        // Clear any body scroll locks
        bodyScrollLock.clearAllBodyScrollLocks();
        
        // Remove overlay if it exists and is visible
        const overlay = document.querySelector('.localizationOverlay');
        if (overlay && overlay.classList.contains('is-visible')) {
          overlay.classList.remove('is-visible');
        }
      }
    }
  }

  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages.replace(/'/g, '"');
    const languages = JSON.parse(languagesJSON);

    const languageOptionsContainer = document.querySelector(".rs-language__selectbox .RevolutionSelectbox--InnerContent");
    const selectedLanguageInput = document.querySelector("#language_code");
    if (!languages) return;
    languageOptionsContainer.innerHTML = "";

    languages.forEach(language => {
      console.log('language', language);
      const label = document.createElement("div");
      label.classList.add("RevolutionSelectbox--Item");
      label.setAttribute("data-action", "selectbox-change");

      label.setAttribute('data-selectboxid','language_code');
      label.setAttribute('data-value', language.iso);

      if (language.iso === selectedLanguageInput.value) {
        label.setAttribute('selected','selected');
      
      }

      label.appendChild(document.createTextNode(language.name));

      languageOptionsContainer.appendChild(label);
    });
  }
}
customElements.define("localization-modal", LocalizationModal);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  connectedCallback() {
      this.bindEvents();
  }

  bindEvents() {
    const formEl = this.element.querySelector('#popupForm');
    if (formEl) {
      formEl.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  handleOpenOptions() {
    const seen  = localStorage.getItem("popup-seen") === "true";
    const subscribed   = localStorage.getItem("popup-subscribed") === "true";
    console.log("seen: ", seen);
    if (
      (this.options.show_only_once && seen)
      || subscribed
    ) {
      return;
    }

    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };

  onSubmit(e) {
    e.preventDefault();

    // Grab & validate email
    const emailEl = this.element.querySelector('#klaviyoEmail');
    const email   = emailEl.value.trim();

    const emailEmptyError = this.element.querySelector(".newsletter-popup__email-empty-error");
    const emailAuthError = this.element.querySelector(".newsletter-popup__email-auth-error");
    const serverError = this.element.querySelector(".newsletter-popup__server-error");

    const successInner = this.element.querySelector(".newsletter__success-inner");
    const duplicateEmailMessage = this.element.querySelector(".newsletter__duplicate-email-wrapper");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = email => emailRegex.test(email);

    if (!email) {
      emailEmptyError.style.display = "block";
      emailAuthError.style.display = "none";
      serverError.style.display = "none";
      return;
    }

    if (!isValidEmail(email)) {
      emailEmptyError.style.display = "none";
      emailAuthError.style.display = "block";
      serverError.style.display = "none";
      return;
    }

    // You exposed this in Liquid already:
    const listId = window.klaviyoListId;
    
    // Build x-www-form-urlencoded body
    const body = new URLSearchParams({
      g: listId,                     // list ID param
      email: email,                  // subscriber email
      '$fields': '$source',          // any extra fields you want
      '$source': 'Popup_Subscribe'   // tag the source
    }).toString();

    // Submit to the same AJAX endpoint
    fetch(
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Cache-Control': 'no-cache'
        },
        body: body
      }
    )
    .then(r => r.json())
    .then(json => {
      if (json.success) {
        if(emailEmptyError) emailEmptyError.style.display = "none";
        if(emailAuthError) emailAuthError.style.display = "none";
        if(serverError) serverError.style.display = "none";
        
        if(json.data.is_subscribed === true){
          successInner.style.display = "none";
          duplicateEmailMessage.style.display = "block";
        }else{
          successInner.style.display = "block";
          duplicateEmailMessage.style.display = "none";
        }

        localStorage.setItem("popup-subscribed", "true");

        this.showSuccessState();
      } else {
        // Server returned success=false
        if(emailEmptyError) emailEmptyError.style.display = "none";
        if(serverError) serverError.style.display = "none";
        emailAuthError.style.display = "block";
      }
    })
    .catch(err => {
      // Network or JSON parse error
      if(emailEmptyError) emailEmptyError.style.display = "none";
      if(emailAuthError) emailAuthError.style.display = "none";
      serverError.style.display = "block";
    });
  }

   showSuccessState() {
    const popup = this.element;
    const form   = popup.querySelector('.newsletter__form');
    const success = popup.querySelector('.newsletter__success-wrapper');

    popup.setAttribute('aria-hidden', 'true');

    const onTransitionEnd = (e) => {
      if (e.propertyName !== 'transform') return;

      form.style.display    = 'none';
      success.style.display = ''; 
      popup.setAttribute('aria-hidden', 'false');

      // clean up listener
      popup.removeEventListener('transitionend', onTransitionEnd);
    };

    popup.addEventListener('transitionend', onTransitionEnd);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);




class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
      new Popup(this.element, true);
  }
}
customElements.define("localization-selectors", LocalizationSelectors);


class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.getAttribute("data-settings") || "{}");

    // Ako je korisnik zatvorio bar u ovoj sesiji – sakrij i resetiraj offset.
    if (sessionStorage.getItem("annBarHidden") === "true") {
      this.element.classList.add("announcement-bar--hidden");
      document.documentElement.style.setProperty("--announcement-dynamic-height", "0px");
      document.documentElement.style.setProperty("--header-offset", "0px");
      return;
    }

    // Sticky klasa na wrapper <section>
    if (this.options.sticky === true && this.parentElement) {
      this.parentElement.classList.add("announcement-bar--sticky");
    }

    this.slides = this.element.querySelectorAll(".announcement-item-block");
    this.animeWrapper = this.element.querySelector(".announcement-bar__anim-wrapper");

    // Init layout (fiksiraj visinu i offset – bez scroll mjerenja)
    this.initLayout();

    // Animacija sitnih slideova po želji
    if (this.options.enableAnimation === true) {
      this.handleSmallAnimation();
    }

    this.bindEvents();
  }

  connectedCallback() {
    // safety: nakon mounta još jednom izračunaj (u slučaju kasnog font loada)
    this.recomputeLayout();
  }

  // --- Layout helpers -------------------------------------------------------

  getFixedBarHeight() {
    // Preferiraj barHeight iz data-settings; fallback na mjerenu visinu wrappera.
    const hOpt = Number(this.options.barHeight);
    if (!Number.isNaN(hOpt) && hOpt > 0) return Math.round(hOpt);

    // Uzmi najpouzdaniju visinu koja već postoji u DOM-u
    const target = this.animeWrapper || this.element;
    return Math.round(target.getBoundingClientRect().height || this.element.clientHeight || 0);
  }

  setHeaderOffset(heightPx) {
    // Ako bar NIJE sticky ili je skriven → offset = 0, inače = visina bara
    const hidden = this.element.classList.contains("announcement-bar--hidden");
    const shouldOffset = this.options.sticky === true && !hidden;
    document.documentElement.style.setProperty("--header-offset", shouldOffset ? `${heightPx}px` : "0px");
  }

  applyHeights(heightPx) {
    // Fiksiraj i "dynamic" var na istu vrijednost (ne mijenjamo na scroll)
    const v = `${heightPx}px`;
    document.documentElement.style.setProperty("--announcement-height-fixed", v);
    document.documentElement.style.setProperty("--announcement-dynamic-height", v);
  }

  updateAnimateWrapperWidth = rafThrottle(() => {
    if (!this.animeWrapper) return;
    const w = Math.round(this.animeWrapper.getBoundingClientRect().width);
    document.documentElement.style.setProperty("--animate-wrapper-width", `${w}px`);
  });

  initLayout() {
    const h = this.getFixedBarHeight();
    this.applyHeights(h);
    this.setHeaderOffset(h);
    this.updateAnimateWrapperWidth();

    // Obavijesti header (i ostale) kolika je efektivna visina
    window.dispatchEvent(new CustomEvent("announcement-height-changed", { detail: { height: h } }));
  }

  recomputeLayout = rafThrottle(() => {
    // Recalc na resize/font load
    const h = this.getFixedBarHeight();
    this.applyHeights(h);
    this.setHeaderOffset(h);
    this.updateAnimateWrapperWidth();
    window.dispatchEvent(new CustomEvent("announcement-height-changed", { detail: { height: h } }));
  });

  // --- Events ---------------------------------------------------------------

  bindEvents() {
    // NEMA scroll listenera – to je uzrok trzanja na iOS-u
    window.addEventListener("resize", this.recomputeLayout, { passive: true });

    this.delegateElement.on("click", "[data-action='ann-bar-close']", this.handleClose.bind(this));
  }

  handleClose() {
    this.element.classList.add("announcement-bar--hidden");
    sessionStorage.setItem("annBarHidden", "true");

    // Spusti visine i offset na 0
    document.documentElement.style.setProperty("--announcement-dynamic-height", "0px");
    document.documentElement.style.setProperty("--header-offset", "0px");

    window.dispatchEvent(new CustomEvent("announcement-height-changed", { detail: { height: 0 } }));
  }

  // Ostavljen prazan radi konzistencije s tvojim kodom
  handleAnnouncementHeightChange(_event) {}

  // --- Slider animacija (ne dira layout) ------------------------------------

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    if (!numSlides) return;

    let currentSlideIndex = 0;

    const animate = () => {
      const previousIndex = (currentSlideIndex - 1 + numSlides) % numSlides;

      mySlides[previousIndex].classList.remove("fade-in");
      mySlides[previousIndex].classList.add("fade-out");
      mySlides[previousIndex].addEventListener(
        "animationend",
        () => mySlides[previousIndex].classList.remove("fade-out"),
        { once: true }
      );

      mySlides[currentSlideIndex].classList.add("fade-in");

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, Number(this.options.interval) || 5000);
    };

    animate();
  }

  handleSmallAnimation() {
    this.slides.forEach((slide, idx) => { if (idx !== 0) slide.style.display = "none"; });

    setTimeout(() => {
      this.fadeSmall();
      this.slides.forEach((slide, idx) => { if (idx !== 0) slide.style.display = "flex"; });
    }, 150);
  }
}

customElements.define("announcement-bar", AnimatedAnnouncementBar);


class UspAnimation extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));

    this.slides = this.element.querySelectorAll(".announcement-item-block");

    if (this.options.enableAnimation === true && this.slides) {
      this.handleSmallAnimation();
    }

    this.firstAnimation = true;

    this.animeWrapper = this.element.querySelector('.usp__anim-wrapper');

    this.applyMaxHeightToWrapper();

  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (!mySlides || !mySlides.length) return;
      
      const previousIndex = (currentSlideIndex - 1 + numSlides) % numSlides;

      if (mySlides[0]) mySlides[0].style.opacity = "0 !important";
      if (mySlides[previousIndex]) {
        mySlides[previousIndex].classList.remove("fade-in");
        mySlides[previousIndex].classList.add("fade-out");

        mySlides[previousIndex].addEventListener("animationend", () => {
          mySlides[previousIndex].classList.remove("fade-out");
        }, { once: true });
      }

      if (mySlides[currentSlideIndex]) {
        mySlides[currentSlideIndex].classList.add("fade-in");
      }

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  applyMaxHeightToWrapper() {
    const blocks = this.element.querySelectorAll('.icon-text-block');
    let maxHeight = 0;

    blocks.forEach((block) => {
      const blockHeight = block.getBoundingClientRect().height;
      if (blockHeight > maxHeight) {
        maxHeight = blockHeight;
      }
    });

    const animWrapper = this.element.querySelector('.announcement-bar__anim-wrapper');
    const duplicateWrapper = this.element.querySelector('.announcement-bar__duplicate-wrapper');

    if (animWrapper) animWrapper.style.height = `${maxHeight}px`;
    if (duplicateWrapper) duplicateWrapper.style.height = `${maxHeight}px`;
  }

  handleSmallAnimation() {

    if(this.slides){
      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = "none";
      });

      setTimeout(() => {
        this.fadeSmall();

        this.slides.forEach((slide, index) => {
          if (index !== 0) slide.style.display = "flex";
        });

        if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
      }, 150);
    }

  }
}

customElements.define("usp-animation", UspAnimation);


var contentCompare = {};
var contentCache = {};
class ConnectedProducts extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.drawer = new Drawer(this.element.querySelector('#size-guide'));
    this.originalTitle = null; // Store the original title
    this.bindEvents();
  }

  connectedCallback() {
    // Ensure DOM is ready and re-bind hover events
    setTimeout(() => {
      this.bindHoverEvents();
    }, 100);
  }

  bindEvents() {

    window.addEventListener(
        "DOMContentLoaded",this.reloadWithoutRefresh.bind(this)
    );

    window.addEventListener('popstate', function(event) {
      location.reload();
    });
    this.delegateElement.on(`click`, `.pdp-link`, this.handleReloadClick.bind(this));
    
    this.bindHoverEvents();
  }

  bindHoverEvents() {

 
    // Use mouseover/mouseout instead of mouseenter/mouseleave for better delegate support
    this.delegateElement.on('mouseover', '.product-module__selectbox-reload', this.handleProductHover.bind(this));
    this.delegateElement.on('mouseout', '.product-module__selectbox-reload', this.handleProductLeave.bind(this));
  }


  handleReloadClick(){

    event.preventDefault();
    const url = event.target.href

    this.updateContentWithoutReload(url);
  }

  handleProductHover(event, target) {
    console.log('Hover triggered!');
    
    // Get the title span element within this connected-products component
    const titleSpan = this.element.querySelector('.product-title');
    if (!titleSpan) {
      console.log('Title span not found!');
      return;
    }

    // Store original title if not already stored
    if (this.originalTitle === null) {
      this.originalTitle = titleSpan.textContent.trim();
      console.log('Original title stored:', this.originalTitle);
    }

    // Get the product title from the image alt attribute
    const productImage = target.querySelector('img');
    if (productImage && productImage.alt) {
      console.log('Changing title to:', productImage.alt);
      titleSpan.textContent = productImage.alt;
    }
  }

  handleProductLeave(event, target) {
    // Restore original title when mouse leaves
    const titleSpan = this.element.querySelector('.product-title');
    if (titleSpan && this.originalTitle !== null) {
      titleSpan.textContent = this.originalTitle;
    }
  }


  updateContentWithoutReload(url) {
    const htmlContent = contentCache[url];
    const compareContent = contentCompare[url];
    history.pushState(null, null, url);

    if (htmlContent) {
      document.body.querySelector(`.product-module`).innerHTML = htmlContent.innerHTML;

      if(compareContent){
          // document.body.querySelector("compare-section").innerHTML = compareContent.innerHTML;

          const oldCompare = document.body.querySelector("compare-section");
          const newCompare = compareContent.cloneNode(true); // clone the full element
          oldCompare.replaceWith(newCompare); // replaces entire custom element
      }

      // Scroll to the top of the page
      window.scrollTo(0, 0);

      // Optionally, update the URL in the address bar without a full page reload
      history.pushState(null, null, url);
      // this.handleExpressButtons();
      if (
          this.element.querySelector(".mainProductDropdownContent--wrapper") &&
          (this.breakpoint === "phone" || this.breakpoint === "tablet")
      ) {
        // new DropdownPDP(this.element.querySelector(".ProductInfo--Wrapper"));
      }
    } else {

      window.location.href = url;

    }

  }

  reloadWithoutRefresh() {
    let pdpLinks = this.element.querySelectorAll('product-component .pdp-link');

    let urlsToFetch = Array.from(pdpLinks).map(link => link.href);

    const fetchAndCacheContent = async (url) => {

      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] =new DOMParser()
              .parseFromString(htmlContent, "text/html")
              .querySelector(".product-module");

            contentCompare[url] = new DOMParser()
                .parseFromString(htmlContent, "text/html").querySelector("compare-section");

        } else {
          console.error('Error fetching data. HTTP status:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Fetch content for all pdpLinks when the page loads
    urlsToFetch.forEach((url) => {
      fetchAndCacheContent(url);
    });

  }
}

customElements.define("connected-products", ConnectedProducts);

class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.allNotifications = this.element.querySelectorAll(
        ".product-module__notify-action"
    );
    this.emailContainer = this.element.querySelector(
        "#product-module__notify-me-input"
    );
    this.subtitle = this.element.querySelector(".product-module__notify-text");
    this.productId = document.querySelector(
        'form[data-product-form] [name="id"]'
    ).dataset.productid;

    this.variantId = document.querySelector(
        '[name="notify_variant"]'
    ).dataset.id;

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
        "click",
        '[data-action="notify-open"]',
        this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="subscribe"]',
        this.handleSubscribe.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="notify-close-success"]',
        this.closeNotifyMeSuccess.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
        "click",
        '[data-action="notify-close"]',
        this.closeNotifyMe.bind(this)
    );
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
  }

  handleSubscribe() {

    const productElem = document.querySelector("product-component")
    const product = JSON.parse(productElem.getAttribute("data-section-settings"));

    const email = this.element.querySelector('[name="notify_email"]').value;
    let promise = SI.create(email, this.variantId, this.productId, product);

    if (email !== "" && email.includes("@")) {
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.showNotification("success");
        } else {
          this.showNotification("error");
        }
      });
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
        el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--success"
        );
        let activeBtn = this.element.querySelector(
            ".product-module__notify-button--success"
        );
        let subsBtn = this.element.querySelector(
            ".product-module__notify-button--subscribe"
        );
        subsBtn.style.display = "none";
        activeBtn.setAttribute("aria-hidden", "false");
        activeNotification.setAttribute("aria-hidden", "false");
        this.emailContainer.value = '';
        this.emailContainer.style.display = "none";
        this.subtitle.style.display = "none";
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    
    // Check if notify-me-popup element exists (if option is enabled)
    const notifyPopup = document.querySelector("notify-me-popup");
    if (!notifyPopup) {
      // If popup doesn't exist, option is disabled - prevent opening
      return;
    }
    
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");

    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );
    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
        "transitionend",
        () => {
          if (e.target.closest('[data-action="notify-close"]')) {
            setTimeout(() => {
              bodyScrollLock.enableBodyScroll(
                  this.element,
                  bodyScrollLockOptions
              );
              this.clearNotifications();
            }, 50);
          } else {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
            this.clearNotifications();
          }
        },
        { once: true }
    );
  }

  closeNotifyMeSuccess(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");

    let activeBtn = this.element.querySelector(
        ".product-module__notify-button--success"
    );
    let subsBtn = this.element.querySelector(
        ".product-module__notify-button--subscribe"
    );

    let activeNotification = this.element.querySelector(
        ".product-module__notify-action--success"
    );

    activeNotification.setAttribute("aria-hidden", "true");
    subsBtn.style.display = "block";
    activeBtn.setAttribute("aria-hidden", "true");
    this.emailContainer.style.display = "flex";
    this.emailContainer.value = '';
    this.subtitle.style.display = "block";

    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );

    this.element.addEventListener(
        "transitionend",
        () => {
          if (e.target.closest('[data-action="notify-close"]')) {
            setTimeout(() => {
              bodyScrollLock.enableBodyScroll(
                  this.element,
                  bodyScrollLockOptions
              );
            }, 50);
          } else {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          }
        },
        { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);


class PairProductSwiper extends HTMLElement{
  constructor() {
    super();
    this.element = this;
    this.swiper = this.element.querySelector(".swiper");

    if(this.swiper)
    {
      this.swiperInstance = new RevolutionSwiper(this.swiper);

      const fadeContainer = this.swiper;
      this.swiperInstance.swiperElement.on('slideChangeTransitionStart', () => {
        this.updateFadeClasses(this.swiperInstance.swiperElement, fadeContainer);
      });

      this.swiperInstance.swiperElement.on('sliderMove', () => {
        this.updateFadeClasses(this.swiperInstance.swiperElement, fadeContainer);
      });

      this.updateFadeClasses(this.swiperInstance.swiperElement, fadeContainer);
    }
  }

  updateFadeClasses(swiper, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both');

    const atStart = swiper.isBeginning;
    const atEnd   = swiper.isEnd;
    if (!atStart && !atEnd) {
      c.add('fade-both');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }
}

customElements.define("pair-products", PairProductSwiper);

class CollectionTabSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element.querySelector(".swiper");

    this.loadType = this.swiperElement?.getAttribute("data-load") || null;

    if (this.swiperElement) {
      this.initSwiper();
    }

    this.bindEvents();
  }

  initSwiper() {
    if (!this.swiperInstance) {
      this.swiperInstance = new RevolutionSwiper(this.swiperElement);
    }
  }

  bindEvents() {
    // window.addEventListener("load", this.reloadWithoutRefresh.bind(this));

    this.delegateElement.on("click", ".tab-link", this.handleTab.bind(this));

    const fadeContainer = this.swiperElement;

    this.swiperInstance.swiperElement.on('slideChangeTransitionStart', () => {
      this.updateFadeClasses(this.swiperInstance.swiperElement, fadeContainer);
    });

    this.swiperInstance.swiperElement.on('sliderMove', () => {
      this.updateFadeClasses(this.swiperInstance.swiperElement, fadeContainer);
    });

    this.updateFadeClasses(this.swiperInstance.swiperElement, fadeContainer);
  }

  handleTab(ev) {
    ev.preventDefault();
    const clickedTab = ev.target;
    const collectionId = clickedTab.dataset.collection;
    const url = clickedTab.href;

    this.setActiveSlide(clickedTab);
    this.filterCollectionItems(collectionId);
    this.updateSwiper(collectionId, url)
    history.pushState(null, null, "");
  }

  filterCollectionItems(collectionId) {
    const allItems = document.querySelectorAll("[data-item-collection]");
    const activeItems = document.querySelectorAll(`[data-item-collection="${collectionId}"]`);

    allItems.forEach((el) => {
      el.style.display = [...activeItems].includes(el) ? "grid" : "none";
    });
  }

  setActiveSlide(tabElement) {
    const currentSlide = tabElement.closest(".swiper-slide");
    const allSlides = document.querySelectorAll(".featured-collection__tabs-item.swiper-slide");
    allSlides.forEach((slide) => {

      const tabLink = slide.querySelector(".tab-link")
      slide.classList.remove("is-active");
      tabLink.classList.remove("is-active");
      if(slide === currentSlide){
        slide.classList.add("is-active");
        tabLink.classList.add("is-active");
      }

    });
  }

  updateSwiper(collectionId, url){
    const event = new CustomEvent('collectionChange', {
      detail: { collectionId, url },
      bubbles: true,
      composed: true
    });

    this.element.dispatchEvent(event);
  }

  updateFadeClasses(swiper, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both');

    const atStart = swiper.isBeginning;
    const atEnd   = swiper.isEnd;
    if (!atStart && !atEnd) {
      c.add('fade-both');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }
}



customElements.define("collection-tab-swiper", CollectionTabSwiper);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateBody = new Delegate(document.body);
    this.loader = this.element.querySelector(".itemLoader");
    this.carouselElement = this.querySelector(".featured-collection__swiper.swiper");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.carousel = new RevolutionSwiper( this.carouselElement );
    new AddToCart(this.element)

    this.bindEvents();
  }

  connectedCallback() {
      if(this.options && this.options["is_collections"] === true){
          if (this.loader) this.loader.classList.add("is-visible");
          this.onLoadPage();
      }
      else{
          if (this.dataset && this.dataset.url) this.loadRecommendations(this.dataset.url)
      }

  }

  bindEvents() {
      this.element.addEventListener("collectionChange",  this.test.bind(this));
  }

    test(event){
        const collectionId = event && event.detail ? event.detail.collectionId : null;
        if (this.loader) this.loader.classList.add("is-visible");
        if (collectionId) this.filterSlides(collectionId)
    }

  onLoadPage(){
        const activeTab = this.element.querySelector(".tab-link.is-active") || this.element.querySelector(".tab-link");
        if (!activeTab || !activeTab.dataset || !activeTab.dataset.collection) {
            if (this.loader) this.loader.classList.remove("is-visible");
            return;
        }
        this.filterSlides(activeTab.dataset.collection);
  }

    filterSlides(collectionId) {
        const swiperWrapper = this.element.querySelector('.swiper-wrapper.featured-collection_products');
        if (!swiperWrapper) {
            if (this.loader) this.loader.classList.remove("is-visible");
            return;
        }

        // 2. Hide all slides, show only matching
        const allSlides = swiperWrapper.querySelectorAll('.swiper-slide');

        let count = 0;

        allSlides.forEach(slide => {
            const shouldShow = slide.dataset.itemCollection === collectionId;

            slide.classList.remove("swiper-slide-active");
            slide.classList.remove("swiper-slide-next");
            if(shouldShow) {
                slide.classList.remove('hidden');
                count += 1;
            }

            else{
                slide.classList.add('hidden');
            }

        });


        const visibleSlides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'))
            .filter(slide => !slide.classList.contains('hidden'));

        if (visibleSlides.length < 4 && responsive.matchesBreakpoint("lap_and_up")) {
            // Remove or reset transform

            swiperWrapper.classList.add("onlyFew");
            swiperWrapper.style.transform = "none";
        }

        else{
            swiperWrapper.classList.remove("onlyFew");
        }

        if (this.carousel  && this.carousel .swiperElement?.destroy) {
            this.carousel.swiperElement.destroy(true, true);
        }


        if(count > 4){
            // Delay reflow and re-initialize
            requestAnimationFrame(() => {
                if (this.carouselElement) {
                    this.carouselElement.classList.remove("grid")
                    this.carousel  = new RevolutionSwiper(this.carouselElement);
                }
            });

        }

        else{
            if (this.carouselElement) {
                this.carouselElement.classList.add("grid")
            }
        }

        setTimeout(() => {
            this.loader.classList.remove("is-visible");
        }, 500)
    }
  async loadRecommendations(url) {
      try {
          const response = await fetch(url);
          const text = await response.text();

          const html = new DOMParser().parseFromString(text, "text/html");

          const newSwiper = html.querySelector(".featured-collection__swiper.swiper");
          const oldSwiper = this.element.querySelector(".featured-collection__swiper.swiper");

          oldSwiper.swiper.destroy();
          const slides = newSwiper.querySelectorAll(".swiper-slide");

          if (newSwiper) {
              oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);

              if(slides.length > 4){
                  new RevolutionSwiper(newSwiper);
              }
              else{
                  newSwiper.classList.add("grid");
              }

          }
      } catch (e) {
          console.error(e);
      }
  }

}
customElements.define("product-recommendations", ProductRecommendations);



class ProductInfo extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.delegateElement = new Delegate(this.element);

        if (this.carouselElement) {
            this.swiperInstance = new RevolutionSwiper(this.carouselElement);
            this.renderButtons();
        }
    }

    connectedCallback() {
        this.delegateElement.on('click', '[data-action="select-slide"]', this.handleDotClick.bind(this));
        this.swiperInstance.swiperElement.on("slideChange", this.handleSlideChange.bind(this));

        this.delegateElement.on("click", '[data-action="close-mobile-swiper"]', this.closeMobileSwiper.bind(this));

        // Add slide change event for iOS scroll fix
        this.swiperInstance.swiperElement.on("slideChangeTransitionEnd", this.refreshScrollableElements.bind(this));
    }

    disconnectedCallback() {
        // Clean up scroll lock if component is removed
        this.clearIOSScrollLock();
    }



    getVisibleHeight(childEl, containerEl) {
        const childRect = childEl.getBoundingClientRect();
        const containerRect = containerEl.getBoundingClientRect();

        const topVisible = Math.max(containerRect.top, childRect.top);
        const bottomVisible = Math.min(containerRect.bottom, childRect.bottom);

        const visibleHeight = Math.max(0, bottomVisible - topVisible);
        return visibleHeight;
    }





    closeMobileSwiper(){
        const mobileDrawer = this.element.querySelector(".product-info__content__col2");
        
        bodyScrollLock.clearAllBodyScrollLocks();
        this.pageOverlayElement.classList.remove("is-visible");
        
        // Clear iOS scroll lock
        this.clearIOSScrollLock();
        
        // Start the closing animation
        mobileDrawer.setAttribute("aria-hidden", "true");
        
        // Wait for transition to complete before hiding the element
        const handleTransitionEnd = (e) => {
            if (e.target === mobileDrawer && e.propertyName === 'opacity') {
                mobileDrawer.style.display = 'none';
                mobileDrawer.removeEventListener('transitionend', handleTransitionEnd);
            }
        };
        
        mobileDrawer.addEventListener('transitionend', handleTransitionEnd);
        
        // Fallback in case transitionend doesn't fire
        setTimeout(() => {
            mobileDrawer.style.display = 'none';
            mobileDrawer.removeEventListener('transitionend', handleTransitionEnd);
        }, 350); // Slightly longer than CSS transition duration
    }

    handleDotClick() {
        const index = event.target.dataset.index;

        if (this.carouselElement?.swiper && !isNaN(index) && responsive.matchesBreakpoint("lap_and_up")) {
            this.carouselElement.swiper.slideTo(index);

            this.element.querySelectorAll('.product-info__dot').forEach(dot => {
                dot.setAttribute("aria-selected", "false");
            });
            event.target.setAttribute("aria-selected", "true");
        }

        if(!responsive.matchesBreakpoint("lap_and_up")){
            const mobileDrawer = this.element.querySelector(".product-info__content__col2");
            
            // Show element first to enable transition
            mobileDrawer.style.display = 'block';
            
            // Use requestAnimationFrame to ensure display is applied before setting aria-hidden
            requestAnimationFrame(() => {
                mobileDrawer.setAttribute("aria-hidden", "false");
            });
            
            this.carouselElement.swiper.slideTo(index);

            this.pageOverlayElement.classList.add("is-visible");

            this.pageOverlayElement.addEventListener("click", this.closeMobileSwiper.bind(this));

            // Apply multiple methods for iOS body scroll lock
            this.applyIOSScrollLock(mobileDrawer);

            // Refresh scrollable elements after popup opens
            setTimeout(() => {
                this.refreshScrollableElements();
            }, 100);
        }
    }



    handleSlideChange() {
        const activeDot = this.element.querySelector('.product-info__dot[aria-selected="true"]');
        if (activeDot) {
            activeDot.setAttribute("aria-selected", "false");
            activeDot.tabIndex = 0;
        }

        let index =  this.swiperInstance.swiperElement.activeIndex;
        const newDot = this.element.querySelector(`.product-info__dot[data-index="${index}"]`);

        newDot.setAttribute("aria-selected", "true");
        newDot.tabIndex = -1;
    }

    refreshScrollableElements() {
        // Simple iOS fix for scroll elements after slide change
        if (!responsive.matchesBreakpoint("lap_and_up")) {
            const scrollableElements = this.element.querySelectorAll('[data-scrollable]');
            scrollableElements.forEach(element => {
                // Force iOS to re-recognize scrollable areas
                element.style.webkitOverflowScrolling = 'auto';
                requestAnimationFrame(() => {
                    element.style.webkitOverflowScrolling = 'touch';
                });
            });
        }
    }

    applyIOSScrollLock(mobileDrawer) {
        // Use bodyScrollLock as primary method
        bodyScrollLock.disableBodyScroll(mobileDrawer, bodyScrollLockOptions);
        
        // Store original styles
        this.originalBodyPosition = document.body.style.position;
        this.originalBodyTop = document.body.style.top;
        this.originalBodyWidth = document.body.style.width;
        this.originalBodyOverflow = document.body.style.overflow;
        
        // Store current scroll position (multiple methods for compatibility)
        this.scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        
        // Apply iOS-specific body lock only if we have a scroll position or are on mobile
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const shouldApplyFixedPosition = isMobile || this.scrollY > 0;
        
        if (shouldApplyFixedPosition) {
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        } else {
            // For inspect mode/desktop, just use overflow hidden
            document.body.style.overflow = 'hidden';
        }
        
        // Add class for additional CSS control
        document.body.classList.add('product-info-scroll-locked');
        
        // Prevent touchmove on body but allow on scrollable areas
        this.preventBodyTouch = (e) => {
            // Allow touch on scrollable elements and swiper
            if (e.target.closest('[data-scrollable]') || 
                e.target.closest('.swiper-wrapper') || 
                e.target.closest('.swiper')) {
                return;
            }
            
            // Prevent all other touches
            e.preventDefault();
        };
        
        document.addEventListener('touchmove', this.preventBodyTouch, { passive: false });
    }

    clearIOSScrollLock() {
        // Clear bodyScrollLock
        bodyScrollLock.clearAllBodyScrollLocks();
        
        // Remove class first
        document.body.classList.remove('product-info-scroll-locked');
        
        // Store scroll position before restoring styles
        const savedScrollY = this.scrollY || 0;
        
        // Force restore all body styles to empty/default
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.left = '';
        document.body.style.right = '';
        
        // Also try to restore html element
        document.documentElement.style.overflow = '';
        document.documentElement.style.position = '';
        document.documentElement.style.height = '';
        
        // Remove touchmove listener
        if (this.preventBodyTouch) {
            document.removeEventListener('touchmove', this.preventBodyTouch);
            this.preventBodyTouch = null;
        }
        
        // Restore scroll position with multiple attempts
        requestAnimationFrame(() => {
            if (savedScrollY > 0) {
                window.scrollTo(0, savedScrollY);
                document.documentElement.scrollTop = savedScrollY;
                document.body.scrollTop = savedScrollY;
            }
            
            // Additional check after short delay
            setTimeout(() => {
                // Force enable scrolling by removing any remaining restrictions
                document.body.style.cssText = '';
                document.documentElement.style.cssText = '';
                
                if (savedScrollY > 0) {
                    window.scrollTo(0, savedScrollY);
                }
                
                // Debug: log if scroll is still locked
                console.log('Body overflow:', window.getComputedStyle(document.body).overflow);
                console.log('HTML overflow:', window.getComputedStyle(document.documentElement).overflow);
                console.log('Body position:', window.getComputedStyle(document.body).position);
            }, 100);
        });
        
        // Reset stored values
        this.scrollY = null;
        this.originalBodyPosition = null;
        this.originalBodyTop = null;
        this.originalBodyWidth = null;
        this.originalBodyOverflow = null;
    }

    renderButtons() {
        const slides = this.element.querySelectorAll('.swiper-slide');

        slides.forEach((slide, index) => {
            const x = slide.getAttribute("data-x");
            const y = slide.getAttribute("data-y");
            const imageWrapper = this.element.querySelector(".product-info__image-wrapper");

            if (!x || !y || !imageWrapper) return;

            const button = document.createElement("button");
            button.className = "product-info__dot";
            button.setAttribute("aria-selected", index === 0 ? "true" : "false");
            button.setAttribute("aria-controls", "inspiration__swiper-wrapper");
            button.setAttribute("data-action", "select-slide");
            button.setAttribute("data-index", index);
            button.setAttribute("tabindex", index === 0 ? "-1" : "0");
            button.style.position = "absolute";
            button.style.top = `${y}%`;
            button.style.left = `${x}%`;

            // Add your SVG icon or use innerHTML to match your Liquid {% render 'icon_pack' with 'plus' %}
            button.innerHTML = `<svg class="plus" width="12" height="12" viewBox="0 0 24 24"><path fill="currentColor" d="M13 11V6h-2v5H6v2h5v5h2v-5h5v-2h-5Z"/></svg> <svg class="minus" width="12" height="12" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13H5v-2h14v2z"/></svg>`;

            // Append the button inside the image wrapper
            imageWrapper.appendChild(button);
        });
    }
}

customElements.define("product-info", ProductInfo);



class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.responsive = new Responsive();

    this.carouselElement = this.element.querySelector(".swiper");

    if (this.carouselElement) {
      if (!responsive.matchesBreakpoint("lap_and_up") && this.options.swiperMobileEnabled) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }
  }
}

customElements.define("collection-showcase", CollectionShowcase);


class CompareSection extends HTMLElement{
    constructor() {
        super();
        this.element = this;

        this.delegateElement = new Delegate(this.element);

        this.swiperWrapper = this.element.querySelector('.compare-section__swiper');

        if(this.swiperWrapper){
            new RevolutionSwiper(this.swiperWrapper);
        }

        // Cache slide templates by handle for reliable cloning
        this.slideTemplates = {};
        const initialSlides = this.element.querySelectorAll('.swiper-slide[data-product-handle]');
        initialSlides.forEach(slide => {
            const handle = slide.getAttribute('data-product-handle');
            if (handle) this.slideTemplates[handle] = slide.innerHTML;
        });

        const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
        selectBoxes.forEach(item => new RevolutionSelectbox(item));

        new AddToCart(this.element);
        this.bindEvents()

    }

    bindEvents(){

        this.delegateElement.on("click", '[data-action="selectbox-submit"]', this.changeProduct.bind(this));
        window.addEventListener('load', this.normalizeSlideHeights.bind(this));
        window.addEventListener('resize', this.normalizeSlideHeights.bind(this));

        this.updateSelectValues()
    }

    async changeProduct(ev, target) {
        ev.preventDefault();
        const productHandle = target.dataset.value;
        const productUrl = target.dataset.url || `/products/${productHandle}`;

        const currentSlide = target.closest('.swiper-slide');
        await this.updateProductCard(currentSlide, productHandle, productUrl);
    }

    async updateProductCard(cardElement, handle, url) {
        // Add loading state
        const cardRoot = cardElement.querySelector('.product-compare-card');
        cardElement.classList.add('is-loading');
        cardRoot?.classList.add('is-loading');
        // Show global spinner overlay inside card
        const loader = cardElement.querySelector('.spinningLoader');
        if (loader) loader.classList.add('is-visible');

        let templateHtml = this.slideTemplates[handle];
        let sourceSlide = null;
        if (!templateHtml) {
            sourceSlide = this.element.querySelector(`.swiper-slide[data-product-handle="${handle}"]`);
        }
        if (!templateHtml && !sourceSlide && url) {
            try {
                const html = await this.fetchPage(url);
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const compare = doc.querySelector('compare-section');
                const fetchedSlide = compare?.querySelector(`.swiper-slide[data-product-handle="${handle}"]`);
                if (fetchedSlide) {
                    templateHtml = fetchedSlide.innerHTML;
                    this.slideTemplates[handle] = templateHtml;
                }
            } catch (e) {
                console.warn('Fetch failed for handle', handle, e);
            }
        }
        if (!templateHtml && sourceSlide) {
            templateHtml = sourceSlide.innerHTML;
            this.slideTemplates[handle] = templateHtml;
        }
        if (!templateHtml) {
            console.warn(`No slide/template found for handle: ${handle}`);
            cardRoot?.classList.remove('is-loading');
            return;
        }

        // Preserve previous aria-hidden state
        const previousAria = cardElement.getAttribute("aria-hidden");
        // Preserve previous dropdown content as fallback (for cases like main product where content may be missing)
        const previousSelectBox = cardElement.querySelector('.RevolutionSelectbox');
        const previousContent = previousSelectBox?.querySelector('.RevolutionSelectbox--Content');
        const previousContentHTML = previousContent ? previousContent.outerHTML : '';

        // Replace content of the current slide with template content
        cardElement.innerHTML = templateHtml;
        cardElement.setAttribute("data-product-handle", handle);
        if (previousAria !== null) { cardElement.setAttribute("aria-hidden", previousAria); } else { cardElement.removeAttribute("aria-hidden"); }

        // Re-init dropdown inside this slide only
        let selectBox = cardElement.querySelector('.RevolutionSelectbox');
        if (selectBox) {
            // Ensure button is enabled
            const btn = selectBox.querySelector('.RevolutionSelectbox--Button');
            btn?.removeAttribute('disabled');
            // Ensure arrow icon is present (Liquid may omit it on main slide templates)
            if (btn && !btn.querySelector('svg')) {
                const arrowSvg = `\n<svg class="Svg Svg--arrow_down" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M16.078 6.81289C15.9304 6.81204 15.7884 6.87001 15.6836 6.974L9.96692 12.6907L4.25025 6.974C4.02983 6.78524 3.70125 6.79793 3.49605 7.00313C3.29084 7.20834 3.27815 7.53691 3.46692 7.75734L9.96692 14.2629L16.4725 7.75734C16.6288 7.59789 16.6744 7.36037 16.5884 7.15434C16.5023 6.94831 16.3013 6.81382 16.078 6.81289Z" fill="#181B1A"/>\n  <path d="M16.078 6.81289C15.9304 6.81204 15.7884 6.87001 15.6836 6.974L9.96692 12.6907L4.25025 6.974C4.02983 6.78524 3.70125 6.79793 3.49605 7.00313C3.29084 7.20834 3.27815 7.53691 3.46692 7.75734L9.96692 14.2629L16.4725 7.75734C16.6288 7.59789 16.6744 7.36037 16.5884 7.15434C16.5023 6.94831 16.3013 6.81382 16.078 6.81289Z" fill="black" fill-opacity="0.2"/>\n</svg>`;
                btn.insertAdjacentHTML('beforeend', arrowSvg);
            }
            // Ensure content exists; if not, inject previous content as fallback
            if (!selectBox.querySelector('.RevolutionSelectbox--Content') && previousContentHTML) {
                selectBox.insertAdjacentHTML('beforeend', previousContentHTML);
            }
            // Replace the whole selectbox node to clear old event bindings
            const parent = selectBox.parentNode;
            const clone = selectBox.cloneNode(true);
            parent.replaceChild(clone, selectBox);
            selectBox = clone;
            new RevolutionSelectbox(selectBox);
        }

        requestAnimationFrame(() => {
            this.updateSelectValues();
            this.normalizeSlideHeights();
            cardElement.classList.remove('is-loading');
            cardElement.querySelector('.product-compare-card')?.classList.remove('is-loading');
            const loader = cardElement.querySelector('.spinningLoader');
            if (loader) loader.classList.remove('is-visible');
        });

    }

    async fetchPage(url){
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.text();
    }

    updateSelectValues(){
        const slides = this.element.querySelectorAll('.swiper-slide');
        slides.forEach((slide) => {
            const options = slide.querySelectorAll('.product-element');
            const currentHandle = slide.getAttribute('data-product-handle');
            let visibleCount = 0;
            options.forEach((option) => {
                const optionHandle = option.getAttribute('data-value');
                if (optionHandle === currentHandle) {
                    option.style.display = 'none';
                } else {
                    option.style.display = '';
                    option.style.padding = '0.932rem 1rem';
                    visibleCount += 1;
                }
            });

            const selectBox = slide.querySelector('.RevolutionSelectbox');
            const button = selectBox?.querySelector('.RevolutionSelectbox--Button');
            const content = selectBox?.querySelector('.RevolutionSelectbox--Content');
            if (selectBox && button) {
                if (!visibleCount) {
                    // No options: keep title, disable interactions, hide arrow, close content
                    button.setAttribute('disabled', 'true');
                    button.style.pointerEvents = 'none';
                    // close dropdown if it was open
                    if (content) {
                        content.setAttribute('aria-hidden', 'true');
                        content.style.display = 'none';
                    }
                    // remove arrow icon if present
                    const arrow = button.querySelector('svg');
                    if (arrow) arrow.remove();
                } else {
                    // Options available: enable and ensure arrow icon exists
                    button.removeAttribute('disabled');
                    button.style.pointerEvents = '';
                    if (!button.querySelector('svg')) {
                        const arrowSvg = `\n<svg class="Svg Svg--arrow_down" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d=\"M16.078 6.81289C15.9304 6.81204 15.7884 6.87001 15.6836 6.974L9.96692 12.6907L4.25025 6.974C4.02983 6.78524 3.70125 6.79793 3.49605 7.00313C3.29084 7.20834 3.27815 7.53691 3.46692 7.75734L9.96692 14.2629L16.4725 7.75734C16.6288 7.59789 16.6744 7.36037 16.5884 7.15434C16.5023 6.94831 16.3013 6.81382 16.078 6.81289Z\" fill=\"#181B1A\"/>\n  <path d=\"M16.078 6.81289C15.9304 6.81204 15.7884 6.87001 15.6836 6.974L9.96692 12.6907L4.25025 6.974C4.02983 6.78524 3.70125 6.79793 3.49605 7.00313C3.29084 7.20834 3.27815 7.53691 3.46692 7.75734L9.96692 14.2629L16.4725 7.75734C16.6288 7.59789 16.6744 7.36037 16.5884 7.15434C16.5023 6.94831 16.3013 6.81382 16.078 6.81289Z\" fill=\"black\" fill-opacity=\"0.2\"/>\n</svg>`;
                        button.insertAdjacentHTML('beforeend', arrowSvg);
                    }
                }
            }
        });

        const selectBoxes = this.element.querySelectorAll('.RevolutionSelectbox');
        selectBoxes.forEach(item => new RevolutionSelectbox(item));
    }




    normalizeSlideHeights() {
        const slides = this.element.querySelectorAll('.swiper-slide'); // adjust selector
        let maxHeight = 0;

        slides.forEach(slide => {
            slide.style.height = 'auto'; // reset
            const height = slide.offsetHeight;
            if (height > maxHeight) maxHeight = height;
        });

        slides.forEach(slide => {
            slide.style.height = `${maxHeight}px`;
        });

        new RevolutionSwiper(this.swiperWrapper);
    }
}

customElements.define("compare-section", CompareSection);


class BlogShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element.querySelector('.swiper');

    const rev = new RevolutionSwiper(this.swiperElement);
  }
}
customElements.define('blog-showcase', BlogShowcase);

class FadeText extends HTMLElement {
  connectedCallback() {
    const inner = this.innerHTML;
    this.innerHTML = `
      <div class="fade-wrapper u-p2 fade-text">
        ${inner}
      </div>
    `;
  }
}
customElements.define('fade-text', FadeText);

class CollectionWrapperHeader extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.toggleButton = null;
    this.description = null;
    this.moreButton = null;
    this.lessButton = null;
    this.isExpanded = false;
    this.resizeObserver = null;
    this.checkClampedDebounced = this.debounce(this.checkTextClamped.bind(this), 150);
  }

  connectedCallback() {
    // Cache DOM elements for better performance
    this.toggleButton = this.element.querySelector('[data-collection-toggle]');
    this.description = this.element.querySelector('.collection-description p');
    
    if (this.toggleButton) {
      this.moreButton = this.toggleButton.querySelector('.more');
      this.lessButton = this.toggleButton.querySelector('.less');
      
      // Set up accessibility attributes
      this.initializeAccessibility();
    }
    
    this.bindEvents();
    this.initializeTextClamping();
  }

  disconnectedCallback() {
    // Clean up ResizeObserver to prevent memory leaks
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  bindEvents() {
    this.domDelegate.on("click", "[data-collection-toggle]", this.handleToggle.bind(this));
  }

  initializeAccessibility() {
    if (!this.toggleButton || !this.description) return;

    // Generate unique IDs for ARIA relationship
    const descriptionId = `collection-desc-${Math.random().toString(36).substr(2, 9)}`;
    
    // Set up ARIA attributes
    this.description.id = descriptionId;
    this.toggleButton.setAttribute('aria-controls', descriptionId);
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.setAttribute('type', 'button');
    
    // Add screen reader friendly text
    const srText = document.createElement('span');
    srText.className = 'sr-only';
    srText.textContent = ' for collection description';
    this.toggleButton.appendChild(srText);
  }

  initializeTextClamping() {
    if (!this.description || !this.toggleButton) return;

    // Initial check
    requestAnimationFrame(() => {
      this.checkTextClamped();
      this.setupResizeObserver();
    });
  }

  setupResizeObserver() {
    if (!window.ResizeObserver || !this.description) return;

    this.resizeObserver = new ResizeObserver(entries => {
      this.checkClampedDebounced();
    });

    this.resizeObserver.observe(this.description);
  }

  checkTextClamped() {
    if (!this.description || !this.toggleButton) return;
    
    // Temporarily remove expanded class to check original clamping
    const wasExpanded = this.isExpanded;
    if (wasExpanded) {
      this.description.classList.remove('expanded');
    }
    
    const isOverflowing = this.isTextClamped();
    
    // Restore expanded state if it was expanded
    if (wasExpanded) {
      this.description.classList.add('expanded');
    }
    
    if (isOverflowing) {
      this.toggleButton.style.display = 'flex';
      // Only set initial state if not already initialized
      if (!this.toggleButton.hasAttribute('data-initialized')) {
        this.setToggleState(false); // Start in collapsed state
        this.toggleButton.setAttribute('data-initialized', 'true');
      }
    } else {
      this.toggleButton.style.display = 'none';
      // Reset expanded state if button is hidden
      if (this.isExpanded) {
        this.description.classList.remove('expanded');
        this.isExpanded = false;
      }
    }
  }

  isTextClamped() {
    if (!this.description) return false;
    
    // Check if text overflows when in collapsed state
    return this.description.scrollHeight > this.description.clientHeight + 1;
  }

  handleToggle(ev, target) {
    ev.preventDefault();
    
    this.isExpanded = !this.isExpanded;
    this.setToggleState(this.isExpanded);
    
    // Announce state change to screen readers
    this.announceStateChange();
  }

  setToggleState(expanded) {
    if (!this.description || !this.toggleButton) return;

    // Update DOM state
    if (expanded) {
      this.description.classList.add('expanded');
      if (this.moreButton) this.moreButton.classList.remove('show');
      if (this.lessButton) this.lessButton.classList.add('show');
    } else {
      this.description.classList.remove('expanded');
      if (this.moreButton) this.moreButton.classList.add('show');
      if (this.lessButton) this.lessButton.classList.remove('show');
    }

    // Update ARIA attributes for accessibility
    this.toggleButton.setAttribute('aria-expanded', expanded.toString());
    this.isExpanded = expanded;
  }

  announceStateChange() {
    // Create a live region announcement for screen readers
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'sr-only';
    announcement.textContent = this.isExpanded ? 
      'Collection description expanded' : 
      'Collection description collapsed';
    
    document.body.appendChild(announcement);
    
    // Remove after announcement
    setTimeout(() => {
      document.body.removeChild(announcement);
    }, 1000);
  }

  // Utility function for debouncing resize events
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
customElements.define('collection-wrapper-header', CollectionWrapperHeader);

class BlogPostCustom extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.responsive = new Responsive();
    this.responsive.addResizeListener(this, this.handleResize);
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element.querySelector('.swiper');
    this.handleResize();
  }

  handleResize(){
    if(this.responsive.matchesBreakpoint("pocket") && !this.carousel){
      this.carousel = new RevolutionSwiper(this.swiperElement);
    }else if(this.responsive.matchesBreakpoint("lap_and_up") && this.carousel){
      this.carousel.swiperElement.destroy(true,true);
      this.carousel = null;
    }
  }
}
customElements.define('blog-post-custom', BlogPostCustom);


class CartCollections extends HTMLElement{
    constructor() {
        super();
        this.element = this;
        this.swiper = this.element.querySelector(".cart-collection-showcase__swiper");

        if(this.swiper)
        {
            this.swiperInstance = new RevolutionSwiper(this.swiper);
        }
    }
}
customElements.define("cart-collections", CartCollections);

class CartPairProducts extends HTMLElement{
  constructor() {
    super();
    this.element = this;

    this.swiper = this.element.querySelector(".cart-pair-products_products");


    if(this.swiper)
    {
      this.swiperInstance = new RevolutionSwiper(this.swiper);
    }
  }
}

customElements.define("cart-pair-products", CartPairProducts);

class ArticleComments extends HTMLElement {
  constructor() {
    super();
    // Read total comments from the HTML attribute
    this.totalComments = parseInt(this.dataset.totalComments, 10) || 0;
    this.remainingCountSpan = this.querySelector('.article-comments__remaining-count');

    // Core elements
    this.delegateElement = new Delegate(this);
    this.articleWrapper = this.querySelector(".article-comments__main-container");
    this.showLessButton = this.querySelector(".article-comments__show-less-button");
    this.commentForm = this.querySelector("#comment_form");
    this.delegateElement.on("click", '[data-action="new-comment"]', this.revealCommentForm.bind(this));

    // Bind form submit
    if (this.commentForm) {
      this.delegateElement.on("submit", "#comment_form", this.customSubmit.bind(this));
    }

    // Restore focus after comment submit
    const commentContainer = this.querySelector('.comment-form__container');
    if (sessionStorage.getItem('comment-submitted')) {
      sessionStorage.removeItem('comment-submitted');
      if (commentContainer) {
        commentContainer.setAttribute('tabindex', '-1');
        commentContainer.focus();
      }
    }

    // If we just submitted a comment and the server-side count hasn't caught up yet,
    // optimistically bump the heading count once on the returned page load.
    const successAlert = this.querySelector('.AlertSuccess');
    const prevCountRaw = sessionStorage.getItem('prev-article-comments-count');
    if (successAlert && prevCountRaw) {
      const prevCount = parseInt(prevCountRaw, 10);
      if (!Number.isNaN(prevCount) && this.totalComments <= prevCount) {
        this.setHeadingCount(prevCount + 1);
        this.totalComments = prevCount + 1;
      }
      sessionStorage.removeItem('prev-article-comments-count');
    }

    // Show comment form if there are no comments or alert is present
    if (!this.querySelector(".article-comments__comment") || document.querySelector(".AlertSuccess") || document.querySelector(".AlertError")) {
      if (this.commentForm) {
        this.commentForm.style.display = "flex";
      }

      const newCommentBtn = this.querySelector(".article-comments__new-comment-button");
      if (newCommentBtn) {
        newCommentBtn.style.display = "none";
      }
    }

    // Wire events and initial UI state
    this.bindEvents();
    this.toggleButton();
    this.updateRemaining();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="load-more"]', this.loadMore.bind(this));
    this.delegateElement.on("click", '[data-action="show-less"]', this.showLess.bind(this));
    this.delegateElement.on("click", '[data-action="scroll-to-comment-form"]', this.scrollToCommentForm.bind(this));
    this.delegateElement.on("change", "[data-state='required']", this.toggleButton.bind(this));
  }

  revealCommentForm(event, target) {
    event.preventDefault();
    target.style.display = "none";
    this.commentForm.style.display = "flex";
  }

  toggleButton() {
    let enabled = true;
    this.querySelectorAll("[data-state='required']").forEach(field => {
      if (field.type === "checkbox" ? !field.checked : field.value.trim() === "") {
        enabled = false;
      }
    });
    const submitBtn = this.querySelector(".article-comments__submit-button");
    if (submitBtn) {
      enabled ? submitBtn.removeAttribute("disabled") : submitBtn.setAttribute("disabled", true);
    }
  }

  escapeSelector(id) {
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  setHeadingCount(newCount) {
    const heading = this.querySelector('.article-comments__heading');
    if (!heading) return;
    const original = heading.textContent || '';
    if (/\(\s*\d+\s*\)/.test(original)) {
      heading.textContent = original.replace(/\(\s*\d+\s*\)/, `(${newCount})`);
    } else {
      heading.textContent = `${original.trim()} (${newCount})`;
    }
    this.dataset.totalComments = String(newCount);
    this.updateRemaining();
  }

  updateRemaining() {
    const shown = this.querySelectorAll('.article-comments__comment').length;
    const remaining = this.totalComments - shown;
    // update the number (in parentheses)
    if (this.remainingCountSpan) {
      this.remainingCountSpan.textContent = remaining > 0 ? `(${remaining})` : '';
    }

    // always ensure it's inside the ButtonText
    const btnText = this.querySelector('.article-comments__load-more-button .ButtonText');
    if (btnText && this.remainingCountSpan) {
      btnText.appendChild(this.remainingCountSpan);
    }
  }

  async loadMore(event, target) {
    event.preventDefault();
    const href = target.dataset.href;
    if (!href) return console.error("Missing data-href on load-more");

    const loader = this.querySelector(".article-comments__load-more-button .itemLoader");
    try {
      loader?.classList.add("is-visible");
      await new Promise(r => setTimeout(r, 300));

      const resp = await fetch(`${window.routes.localeRootUrl}${href}`, { credentials: "same-origin" });
      if (!resp.ok) throw new Error(resp.statusText);
      const html = await resp.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      // Append new comments
      doc.querySelectorAll(".article-comments__comment").forEach(c => {
        const id = c.getAttribute('id') && this.escapeSelector(c.getAttribute('id'));
        if (!id || this.querySelector(`#${id}`)) return;
        this.articleWrapper.appendChild(c);
      });
      new RevolutionAnimation(this);

      // Swap or remove Load more button
      const newBtn = doc.querySelector("[data-action='load-more']");
      const oldBtn = this.querySelector(".article-comments__load-more-button");
      const btnContainer = this.querySelector('.article-comments__buttons');

      if (newBtn) {
        oldBtn.replaceWith(newBtn);
        this.showLessButton.classList.add('hidden'); // still more pages
      } else {
        oldBtn.remove();
        btnContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden'); // end reached
      }

      this.updateRemaining();
    } catch (err) {
      console.error("Failed to load more comments:", err);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }

  async showLess(event, target) {
    event.preventDefault();
    const url = target.dataset.firstPageUrl;
    if (!url) return;

    try {
      const resp = await fetch(`${window.routes.localeRootUrl}${url}`, { credentials: "same-origin" });
      if (!resp.ok) throw new Error(resp.statusText);
      const html = await resp.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      // Restore first page comments
      const comments = doc.querySelectorAll(".article-comments__comment");
      this.articleWrapper.innerHTML = "";
      comments.forEach(c => this.articleWrapper.appendChild(c));
      new RevolutionAnimation(this);

      // Hide Show Less, restore Load More
      this.showLessButton.classList.add('hidden');
      const loadMoreBtn = doc.querySelector(".article-comments__load-more-button");
      if (loadMoreBtn) {
        this.querySelector('.article-comments__buttons').appendChild(loadMoreBtn);
      }

      this.updateRemaining();

      // Scroll back up
      const top = this.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top, behavior: 'smooth' });
    } catch (err) {
      console.error("Failed to show less:", err);
    }
  }

  scrollToCommentForm(event) {
    event.preventDefault();
    if (!this.commentForm) return;
    const rect = this.commentForm.getBoundingClientRect();
    window.scrollTo({ top: rect.top + window.scrollY - 150, behavior: 'smooth' });
  }

  customSubmit(event) {
    sessionStorage.setItem('comment-submitted', 'true');
    sessionStorage.setItem('prev-article-comments-count', String(this.totalComments));
    event.preventDefault();
    // ... your existing title/tag injection logic ...
    this.commentForm.submit();
  }
}

customElements.define("article-comments", ArticleComments);

class QuoteContainer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element.querySelector('.swiper');

    const rev = new RevolutionSwiper(this.swiperElement);
  }
}
customElements.define('quote-container', QuoteContainer);

class QuoteText extends HTMLElement {
  constructor() {
    super();
    this.animate = this.animate.bind(this);
  }

  connectedCallback() {
          const wrappers = this.querySelectorAll('p');
          if (wrappers.length === 0) {
              this._wrapElement(this);
          } else {
              wrappers.forEach((p) => this._wrapElement(p));
          }

          this.chars = Array.from(this.querySelectorAll('span'));
          this.animate();

          window.addEventListener('scroll', this.animate);
          window.addEventListener('resize', this.animate);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.animate);
    window.removeEventListener('resize', this.animate);
  }

  _wrapElement(el) {
    const text = el.textContent;
    el.innerHTML = Array.from(text)
      .map((ch) => `<span>${ch}</span>`)
      .join('');
  }

  animate() {
    const rect = this.getBoundingClientRect();
    const vh = window.innerHeight;
    const startY = vh * 0.85;
    const endY = vh * 0.2;
    const height = rect.height;

    let t = (startY - rect.top) / (startY - (endY - height));
    t = Math.min(Math.max(t, 0), 1);

      const fullyScrolled = window.innerHeight + window.scrollY >= document.body.offsetHeight;
      if (fullyScrolled) t = 1;

    const total = this.chars.length;
    this.chars.forEach((span, i) => {
      const threshold = (i + 1) / total;
      if (t >= threshold) {
        span.classList.add('quote-text__char--on');
        span.classList.remove('quote-text__char--off');
      } else {
        span.classList.add('quote-text__char--off');
        span.classList.remove('quote-text__char--on');
      }
    });
  }
}

customElements.define('quote-text', QuoteText);

class InfiniteScroll {
  // Prevent multiple concurrent loads
  loading = false;
  constructor(container, paginationElement, restoreState) {
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;

    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload = window.performance
      .getEntriesByType('navigation')
      .some((entry) => entry.type === 'reload');

    if (this.loadType === 'scroll' &&
      this.restoreState &&
      sessionStorage.getItem('pageState') > 1 &&
      window.location.href === sessionStorage.getItem('pageStateURL') &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }

    if (this.loadType === 'click') {
      this.initialize(); 
    }
  }

  initObserver() {
    const sentinel = document.querySelector(this.paginationElementSelector);
    if (!sentinel) return;
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0 };
    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(sentinel);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener(
        'beforeunload',
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)
      .dataset.page;

    sessionStorage.setItem('pageState', currentPage);
    sessionStorage.setItem('pageStateURL', currentUrl);
    sessionStorage.setItem('pageStateScroll', scrollPositionY);
  }

  initialize() {
    if (this.loadType === 'scroll') {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {
      this.domDelegate.on(
        'click',
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === 'scroll') {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        'click',
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        this.running = false;
        this.destroy();
        return;
      }

      if (this.running) return;
      this.running = true;

      if (this.loadType === 'scroll') {
        this.handleScroll();
      } else {
        this.initialize();
      }
    });
  }

  handleScroll() {
    if (this.loading) return;
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector('a');

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const urlObj = new URL(nextPageUrl, window.location.origin);

        const nextPage = parseInt(urlObj.searchParams.get('page') || '1', 10);

        this.paginationElement.dataset.page = nextPage;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    const loader = e.target.closest('a')?.querySelector('.itemLoader');
    if (loader) {
      loader.classList.add('is-visible');
    }

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector('a');

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem('pageState'));
      for (let i = 2; i <= limit; i++) {
        let url;

        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: 'same-origin',
            method: 'GET',
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: 'same-origin',
          method: 'GET',
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    if (this.loading) return;
    this.loading = true;
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error('Error fetching or parsing data:', error);
    }
    this.loading = false;
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');

    const listSelector =
      this.containerSelector + ' .blog-articles-grid__articles';
    const newList = doc.querySelector(listSelector);
    if (!newList) return;

    const newPager = doc.querySelector(this.paginationElementSelector);

    const targetList = document.querySelector(listSelector);
    if (!targetList) return;

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    targetList.insertAdjacentHTML('beforeend', newList.innerHTML);

    if (newPager) {
      this.mainContainer.insertAdjacentHTML('afterend', newPager.outerHTML);
    const newCounter = doc.querySelector('.blog-articles-grid__article-count');
    const currentCounter = document.querySelector('.blog-articles-grid__article-count');
    if (newCounter && currentCounter) {
      currentCounter.innerHTML = newCounter.innerHTML;
    }
    }

    if (this.loadType === 'scroll' && this.paginationElement) {
      const oldPage = parseInt(this.paginationElement.dataset.page, 10) || 1;
      this.paginationElement.dataset.page = oldPage + 1;
    }

    if (lastPromise) {
      this.initialize();
      this.initObserver();
      if (restoreContent) this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent('pagination:finished', { bubbles: true })
    );
    document.dispatchEvent(new CustomEvent('update-favorites'));
    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem('pageStateScroll'));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
    }
  }
}

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.activeSlide = this.element.querySelector('.blog__current-tag');
  }

  connectedCallback() {
    this.carouselElement = this.element.querySelector(
      '.blog__tags--swiper.swiper'
    );

    if (this.carouselElement) {
      const swiperElement = new RevolutionSwiper(this.carouselElement);
      const slides = Array.from(
        this.carouselElement.querySelectorAll('.swiper-slide')
      );
      const activeIndex = slides.indexOf(this.activeSlide);

      swiperElement.swiperElement.slideTo(activeIndex);
    }

    new InfiniteScroll('#blog-article--wrapper', '#infinite-scroll', true);

    this.delegateElement = new Delegate(this.element);
    this.delegateElement.on('click', '.blog-item__button', (event, target) => {
      event.preventDefault();
      const featured = document.querySelector('.blog-articles-grid__featured');
      if (
        featured &&
        !featured.classList.contains('blog-articles-grid__featured--more')
      ) {
        featured.classList.add('blog-articles-grid__featured--more');
      }
      featured.classList.add('blog-articles-grid__featured--fade');
      setTimeout(() => {
        featured.classList.remove('blog-articles-grid__featured--fade');
      }, 400);
    });
  }
}

customElements.define('blog-section', BlogSection);

class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.isAnimating = false;
  }

  connectedCallback() {
    this.selectElements();
    this.bindEvents();
    this.wrapWithFadeWrapper(this.middleContainer);
    this.wrapWithFadeWrapper(this.rightContainer);
    this.renderLeftButtons();

    const firstLeftButton = this.leftContainer.querySelector(".faq__button--left");
    if (firstLeftButton) {
      const leftId = firstLeftButton.getAttribute("left-id");
      this.renderMiddleButtons(leftId);
      const firstMiddleButton = this.middleContainer.querySelector(".faq__button--middle");
      if (firstMiddleButton) {
        const middleId = firstMiddleButton.getAttribute("middle-id");
        this.renderRightContent(leftId, middleId);
        firstMiddleButton.setAttribute("content-shown", "true");
      }
      firstLeftButton.setAttribute("aria-expanded", "true");
    }
  }

  selectElements() {
    this.leftContainer = this.element.querySelector(".faq-section__content-grid--left");
    this.middleContainer = this.element.querySelector(".faq-section__content-grid--middle");
    this.rightContainer = this.element.querySelector(".faq-section__content-grid--right");
    
    // Cache fade wrappers for better performance
    this.middleFade = null;
    this.rightFade = null;
  }

  // Get or create cached fade wrapper references
  getMiddleFade() {
    if (!this.middleFade) {
      this.middleFade = this.middleContainer.querySelector(".faq__fade-wrapper");
    }
    return this.middleFade;
  }

  getRightFade() {
    if (!this.rightFade) {
      this.rightFade = this.rightContainer.querySelector(".faq__fade-wrapper");
    }
    return this.rightFade;
  }

  bindEvents() {
    this.delegateElement.on("click", ".faq__button--left", this.handleLeftClick.bind(this));
    this.delegateElement.on("click", ".faq__button--middle", this.handleMiddleClick.bind(this));
  }

  wrapWithFadeWrapper(container) {
    const wrapper = document.createElement("div");
    wrapper.className = "faq__fade-wrapper";
    while (container.firstChild) {
      wrapper.appendChild(container.firstChild);
    }
    container.appendChild(wrapper);
  }

  handleLeftClick(event, target) {
    const leftId = target.getAttribute("left-id");

    // Prevent multiple clicks during animation
    if (this.isAnimating) return;
    this.isAnimating = true;

    this.leftContainer.querySelectorAll(".faq__button--left").forEach((btn) => {
      btn.setAttribute("aria-expanded", btn === target ? "true" : "false");
    });

    const middleFade = this.getMiddleFade();
    const rightFade = this.getRightFade();

    // Start fade out
    middleFade.style.opacity = "0";
    rightFade.style.opacity = "0";

    // Wait for fade out to complete, then update content
    this.waitForTransition(middleFade).then(() => {
      middleFade.innerHTML = "";
      rightFade.innerHTML = "";

      this.renderMiddleButtons(leftId);
      const firstMiddle = middleFade.querySelector(".faq__button--middle");
      if (firstMiddle) {
        const middleId = firstMiddle.getAttribute("middle-id");
        firstMiddle.setAttribute("content-shown", "true");
        this.renderRightContent(leftId, middleId);
      }

      // Fade in new content
      this.fadeInElements([middleFade, rightFade]).then(() => {
        this.isAnimating = false;
      });
    });
  }

  handleMiddleClick(event, target) {
    const leftId = target.getAttribute("left-id");
    const middleId = target.getAttribute("middle-id");

    // Prevent multiple clicks during animation
    if (this.isAnimating) return;
    this.isAnimating = true;

    const rightFade = this.getRightFade();

    this.middleContainer.querySelectorAll(".faq__button--middle").forEach((btn) => {
      btn.setAttribute("content-shown", btn === target ? "true" : "false");
    });

    // Start fade out
    rightFade.style.opacity = "0";

    // Wait for fade out to complete, then update content
    this.waitForTransition(rightFade).then(() => {
      rightFade.innerHTML = "";
      this.renderRightContent(leftId, middleId);
      
      // Fade in new content
      this.fadeInElements([rightFade]).then(() => {
        this.isAnimating = false;
      });
    });
  }

  renderLeftButtons() {
    const mobileButtons = document.querySelectorAll(".info__dropdown-button");
    if (!this.leftContainer || !mobileButtons.length) return;

    mobileButtons.forEach((btn) => {
      const tabId = btn.getAttribute("data-tab-id");
      const text = btn.querySelector(".info__dropdown-button--text")?.textContent?.trim();
      if (!tabId || !text) return;

      const newBtn = document.createElement("button");
      newBtn.className = "faq__button--left u-s2";
      newBtn.setAttribute("left-id", tabId);
      newBtn.setAttribute("aria-expanded", "false");
      newBtn.textContent = text;

      this.leftContainer.appendChild(newBtn);
    });
  }

  renderMiddleButtons(leftId) {
    const dropdown = document.querySelector(`.Dropdown.dropdown-border .info__dropdown-button[data-tab-id="${leftId}"]`)?.closest(".Dropdown");
    if (!dropdown) return;

    const content = dropdown.querySelector(".Dropdown--Content");
    const titles = content?.querySelectorAll('[dropdown-item-title]');
    if (!titles) return;

    const middleFade = this.getMiddleFade();

    titles.forEach((titleEl, index) => {
      const middleId = titleEl.getAttribute("dropdown-item-title");
      if (!middleId) return;

      const newBtn = document.createElement("button");
      newBtn.className = "faq__button--middle u-s2";
      newBtn.setAttribute("left-id", leftId);
      newBtn.setAttribute("middle-id", middleId);
      newBtn.setAttribute("content-shown", "false");
      newBtn.textContent = middleId;

      middleFade.appendChild(newBtn);
    });
  }

  renderRightContent(leftId, middleId) {
    const dropdown = document.querySelector(`.Dropdown.dropdown-border .info__dropdown-button[data-tab-id="${leftId}"]`)?.closest(".Dropdown");
    if (!dropdown) return;

    const content = dropdown.querySelector(".Dropdown--Content");
    const titleEl = content?.querySelector(`.faq__tab-title[dropdown-item-title="${middleId}"]`);
    const contentEl = titleEl?.nextElementSibling;
    if (!titleEl || !contentEl || !contentEl.classList.contains("faq__tab-content")) return;

    const rightDiv = document.createElement("div");
    const contentClass = contentEl.getAttribute("class") || "faq__content--right rte";

    rightDiv.setAttribute("class", `faq__content--right ${contentClass.replace("faq__tab-content", "").trim()}`);
    rightDiv.setAttribute("left-id", leftId);
    rightDiv.setAttribute("middle-id", middleId);
    rightDiv.setAttribute("aria-hidden", "false");
    rightDiv.setAttribute("aria-expanded", "true");
    rightDiv.innerHTML = contentEl.innerHTML;

    this.getRightFade().appendChild(rightDiv);
  }

  // Helper method to wait for transition to complete
  waitForTransition(element) {
    return new Promise((resolve) => {
      const handleTransitionEnd = (event) => {
        if (event.target === element && event.propertyName === 'opacity') {
          element.removeEventListener('transitionend', handleTransitionEnd);
          resolve();
        }
      };
      
      element.addEventListener('transitionend', handleTransitionEnd);
      
      // Fallback in case transitionend doesn't fire
      setTimeout(resolve, 450); // Slightly longer than CSS transition (400ms)
    });
  }

  // Helper method to fade in elements
  fadeInElements(elements) {
    return new Promise((resolve) => {
      if (elements.length === 0) {
        resolve();
        return;
      }

      let completedCount = 0;
      const totalElements = elements.length;

      const handleTransitionEnd = (event) => {
        if (event.propertyName === 'opacity') {
          completedCount++;
          if (completedCount === totalElements) {
            elements.forEach(el => el.removeEventListener('transitionend', handleTransitionEnd));
            resolve();
          }
        }
      };

      // Add event listeners and start fade in
      elements.forEach(element => {
        element.addEventListener('transitionend', handleTransitionEnd);
        requestAnimationFrame(() => {
          element.style.opacity = "1";
        });
      });

      // Fallback
      setTimeout(resolve, 450);
    });
  }
}

customElements.define("faq-section", FAQSection);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.swiperEl = this.element.querySelector(".swiper");

    const initMobileSwiper = this.options.mobileSwiperEnabled &&
                             this.options.blockSize > 1 &&
                             !responsive.matchesBreakpoint("lap_and_up");

    const initDesktopSwiper = this.options.blockSize > 4 &&
                              responsive.matchesBreakpoint("lap_and_up");

    if (initMobileSwiper || initDesktopSwiper) {
      this.carousel = new RevolutionSwiper(this.swiperEl);
    }
  }
}

customElements.define("usp-section", UspSection);





class InfiniteScrollCustom {
  constructor(container, paginationElement, restoreState) {
    if (!document.querySelector(container) || !document.querySelector(paginationElement)) return;

    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload =
      (window.performance.navigation && window.performance.navigation.type === 1) ||
      window.performance.getEntriesByType("navigation").map((nav) => nav.type).includes("reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = { root: null, rootMargin: "20px", threshold: 0 };
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), observerOptions);
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener("beforeunload", this.rememberCurrentState.bind(this));
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)?.dataset.page;
    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      window.addEventListener("scroll", this.handleScrollBinder, { passive: true });
    } else {
      this.domDelegate.on("click", `${this.paginationElementSelector} [data-action="load"]`, this.handleClickBinder);
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      window.removeEventListener("scroll", this.handleScrollBinder);
    } else {
      this.domDelegate.off("click", `${this.paginationElementSelector} [data-action="load"]`, this.handleClickBinder);
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(this.paginationElementSelector);
    if (!this.paginationElement) return;

    const rect = this.paginationElement.getBoundingClientRect();
    const top = rect.top - this.treshold;
    const bottom = rect.bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target.closest("a")?.querySelector(".itemLoader")?.classList.add("is-visible");

    this.paginationElement = document.querySelector(this.paginationElementSelector);
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];
    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        const url = hasSearchParameters ? `${window.location.href}&page=${i}` : `${window.location.href}?page=${i}`;
        promises.push(fetch(url, { credentials: "same-origin", method: "GET" }));
      }
    } else {
      const url = `${nextPageUrl}`;
      promises.push(fetch(url, { credentials: "same-origin", method: "GET" }));
    }
    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(responses.map((r) => r.text()));
      contents.forEach((content, index) => {
        this.appendContent(content, index === contents.length - 1, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const doc = new DOMParser().parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(this.paginationElementSelector);
    if (this.paginationElement) this.paginationElement.remove();

    if (contentToAdd) {
      this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);
    }

    if (lastPromise) {
      this.initialize();
      this.initObserver();
    }

    if (lastPromise && restoreContent) this.restoreScroll();

    document.dispatchEvent(new CustomEvent("pagination:finished", { bubbles: true }));
    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));
    if (scrollPosition) {
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
  }
}

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegate = new Delegate(this);
    this.setAttribute('data-ready', 'false');
    this._productFiltersHydrated = false;
    this._pageLoader = null;
    this._ensureAC = null;
    this._filtersAC = null;

    try { this._ensurePageLoader(); } catch(_) {}
    this.productBtn     = this.querySelector('#productBtn');
    this.articleBtn     = this.querySelector('#articleBtn');
    this.productGrid    = this.querySelector('#collection-product');
    this.articleGrid    = this.querySelector('#collection-articles');
    this.productCountEl = this.querySelector('#global-product-count');
    this.articleCountEl = this.querySelector('#global-article-count');
    this.filterBar      = this.querySelector('.filter-bar');

    this._initializing = true;
    this._infScrollInstance = null;
  }

  connectedCallback() {
    // Tab toggles
    this.delegate.on('click', '[data-action="toggle-products"]', e => {
      e.preventDefault();
      this.showProducts();
    });
    this.delegate.on('click', '[data-action="toggle-articles"]', e => {
      e.preventDefault();
      this.showArticles();
    });

    // --- Show something IMMEDIATELY (no blocking overlay) ---
    const urlType = new URLSearchParams(location.search).get('type');
    const hasProd = !!this.querySelector('#collection-product');
    const hasArt  = !!this.querySelector('#collection-articles');

    if (urlType === 'article' && hasArt) {
      this.showArticles(false);
      this._initInfiniteScrollFor('article');
    } else if (urlType === 'product' && hasProd) {
      this.showProducts(false);
      this._initInfiniteScrollFor('product');
    } else if (hasProd) {
      this.showProducts(false);
      this._initInfiniteScrollFor('product');
    } else if (hasArt) {
      this.showArticles(false);
      this._initInfiniteScrollFor('article');
    }

    // Mark ready as soon as something is visible
    this.setAttribute('data-ready', 'true');
    this.updateCounts();

    // Only show overlay if BOTH grids are missing (true first-load hydrate)
    const needHydrate = !hasProd && !hasArt;
    if (needHydrate) this._showPageLoader(true);

    // Fire-and-forget: ensure both tabs are present, then respect URL `type`
    this._ensureArticlesOnRefresh()
      .finally(() => {
        if (needHydrate) this._showPageLoader(false);
        this.setAttribute('data-ready', 'true');
        this.updateCounts();
      });

    // Keep counts refreshed after pagination
    document.addEventListener('pagination:finished', () => this.updateCounts());

    this._initializing = false;
  }

  async _ensureArticlesOnRefresh(){
    const sectionId = this.dataset.id;
    const params = new URLSearchParams(location.search);
    const terms = params.get('q') || this.dataset.searchTerms || '';
    if (!sectionId || !terms) return;

    const base = `${location.pathname}?section_id=${encodeURIComponent(sectionId)}&q=${encodeURIComponent(terms)}`;

    try {
      if (this._ensureAC) try { this._ensureAC.abort(); } catch(_) {}
      this._ensureAC = new AbortController();
      const signal = this._ensureAC.signal;
      const [artRes, prodRes] = await Promise.all([
        fetch(`${base}&type=article`, { signal }),
        fetch(`${base}&type=product`, { signal })
      ]);

      const [artHtml, prodHtml] = await Promise.all([artRes.text(), prodRes.text()]);
      const artDoc  = new DOMParser().parseFromString(artHtml, 'text/html');
      const prodDoc = new DOMParser().parseFromString(prodHtml, 'text/html');

      // Cache which tab is currently visible so we don't flicker
      const currentlyShowing =
        (this.productGrid && this.productGrid.style.display === 'grid') ? 'product' :
        (this.articleGrid && this.articleGrid.style.display === 'grid') ? 'article' : null;

      // --- Update Articles (button/count/grid) ---
      const fetchedArticleBtn    = artDoc.getElementById('articleBtn');
      const fetchedArticleCount  = artDoc.getElementById('global-article-count');
      const fetchedArticlesWrap  = artDoc.getElementById('collection-articles');

      if (fetchedArticleBtn) {
        const toggleWrap = this.querySelector('.main-search__toggle-buttons');
        const currentBtn = this.querySelector('#articleBtn');
        if (toggleWrap && !currentBtn) toggleWrap.appendChild(fetchedArticleBtn.cloneNode(true));
        this.articleBtn = this.querySelector('#articleBtn');
      }
      if (fetchedArticleCount) {
        this.articleCountEl = this.querySelector('#global-article-count') || this.articleCountEl;
        if (this.articleCountEl) this.articleCountEl.textContent = fetchedArticleCount.textContent;
      }
      if (fetchedArticlesWrap) {
        const existing = this.querySelector('#collection-articles');
        if (existing) {
          existing.outerHTML = fetchedArticlesWrap.outerHTML;
          this.articleGrid = this.querySelector('#collection-articles');
          if (currentlyShowing !== 'article') this.articleGrid.style.display = 'none';
        } else {
          const wrapper = this.querySelector('.main-search__collection-wrapper') || this;
          const prodWrap = this.querySelector('#collection-product');
          const clone = fetchedArticlesWrap.cloneNode(true);
          if (currentlyShowing !== 'article') clone.style.display = 'none';
          if (prodWrap && prodWrap.parentElement === wrapper) prodWrap.insertAdjacentElement('afterend', clone);
          else wrapper.appendChild(clone);
          this.articleGrid = this.querySelector('#collection-articles');
        }
      }

      // --- Update Products (button/count/grid wrapper) ---
      const fetchedProductBtn      = prodDoc.getElementById('productBtn');
      const fetchedProductCount    = prodDoc.getElementById('global-product-count');
      const fetchedMainCollection  = prodDoc.querySelector('main-collection-grid[data-search]');

      if (fetchedProductBtn) {
        const toggleWrap = this.querySelector('.main-search__toggle-buttons');
        const currentBtn = this.querySelector('#productBtn');
        if (toggleWrap && !currentBtn) toggleWrap.insertAdjacentElement('afterbegin', fetchedProductBtn.cloneNode(true));
        this.productBtn = this.querySelector('#productBtn');
      }
      if (fetchedProductCount) {
        this.productCountEl = this.querySelector('#global-product-count') || this.productCountEl;
        if (this.productCountEl) this.productCountEl.textContent = fetchedProductCount.textContent;
      }
      if (fetchedMainCollection) {
        const existingMain = this.querySelector('main-collection-grid[data-search]');
        const wrapper = this.querySelector('.main-search__collection-wrapper') || this;
        if (!existingMain) {
          const cloneMain = fetchedMainCollection.cloneNode(true);
          const cloneProductGrid = cloneMain.querySelector('#collection-product');
          if (currentlyShowing !== 'product' && cloneProductGrid) cloneProductGrid.style.display = 'none';
          const afterEl = wrapper.querySelector('#collection-articles');
          if (afterEl) afterEl.insertAdjacentElement('beforebegin', cloneMain); else wrapper.appendChild(cloneMain);
        }
        this.productGrid = this.querySelector('#collection-product');
      }

      // Respect URL type if we fetched the needed tab;
      // otherwise keep whatever is already visible (avoids flicker)
      const urlType = new URLSearchParams(location.search).get('type');
      const haveProd = !!this.querySelector('#collection-product');
      const haveArt  = !!this.querySelector('#collection-articles');

      if (urlType === 'article' && haveArt && currentlyShowing !== 'article') {
        this.showArticles(false);
        this._initInfiniteScrollFor('article');
      } else if (urlType === 'product' && haveProd && currentlyShowing !== 'product') {
        this.showProducts(false);
        this._initInfiniteScrollFor('product');
      } else if (!currentlyShowing) {
        if (haveProd) { this.showProducts(false); this._initInfiniteScrollFor('product'); }
        else if (haveArt) { this.showArticles(false); this._initInfiniteScrollFor('article'); }
      }

      this.updateCounts();
    } catch (err) {
      if (err?.name !== 'AbortError') console.warn('Failed to ensure tabs after refresh:', err);
    }
  }

  updateCounts() {
    const prodView = this.querySelector('.product.view-info');
    const artView  = this.querySelector('.article.view-info');

    const prodGrid = this.querySelector('#collection-product');
    const artGrid  = this.querySelector('#collection-articles');

    const prodCountRaw = prodGrid ? prodGrid.querySelectorAll('.is-product').length : 0;
    const artCountRaw  = artGrid ? artGrid.querySelectorAll('.blog-article').length : 0;

    const mainProdGrid = this.querySelector('#main-collection__grid');
    const totalProductsAttr = mainProdGrid ? parseInt(mainProdGrid.getAttribute('data-total') || '0') : 0;
    const productTotalText = (this.productCountEl?.textContent?.trim()) || (this.dataset.totalProducts || '');
    const totalProductsText = parseInt(String(productTotalText).replace(/[^0-9]/g, '')) || 0;
    const totalProducts = totalProductsAttr || totalProductsText;

    const articleTotalText = (this.articleCountEl?.textContent?.trim()) || (this.dataset.totalArticles || '');
    const totalArticles = parseInt(String(articleTotalText).replace(/[^0-9]/g, '')) || 0;

    const prodCount = totalProducts ? Math.min(prodCountRaw, totalProducts) : prodCountRaw;
    const artCount  = totalArticles ? Math.min(artCountRaw, totalArticles)  : artCountRaw;

    const langOf = (window.languages && window.languages.of) || 'of';
    const langProducts = (window.languages && window.languages.products) || 'products';
    const langArticles = (window.languages && window.languages.articles) || 'articles';

    if (prodView && totalProducts > 0) {
      prodView.innerHTML = `${prodCount} ${langOf} ${totalProducts} ${langProducts}.`;
    }
    if (artView && totalArticles > 0) {
      artView.innerHTML = `${artCount} ${langOf} ${totalArticles} ${langArticles}.`;
    }

    if (totalProducts > 0 && prodCount >= totalProducts) {
      const prodPager = this.querySelector('#infinite-scroll-products');
      if (prodPager) prodPager.querySelector('a')?.remove();
      if (this._infScrollInstance && this.productGrid?.style.display === 'grid') {
        try { this._infScrollInstance.destroy(); } catch(_) {}
        this._infScrollInstance = null;
      }
    }

    if (totalArticles > 0 && artCount >= totalArticles) {
      const artPager = this.querySelector('#infinite-scroll-articles');
      if (artPager) artPager.querySelector('a')?.remove();
      if (this._infScrollInstance && this.articleGrid?.style.display === 'grid') {
        try { this._infScrollInstance.destroy(); } catch(_) {}
        this._infScrollInstance = null;
      }
    }
  }

  async showProducts(updateURL = true) {
    this.productBtn  = this.querySelector('#productBtn') || this.productBtn;
    this.articleBtn  = this.querySelector('#articleBtn') || this.articleBtn;
    this.productGrid = this.querySelector('#collection-product') || this.productGrid;
    this.articleGrid = this.querySelector('#collection-articles') || this.articleGrid;
    this.filterBar   = this.querySelector('.filter-bar') || this.filterBar;

    this.productBtn?.classList.add('active');
    this.productBtn?.setAttribute('aria-selected','true');
    this.articleBtn?.classList.remove('active');
    this.articleBtn?.setAttribute('aria-selected','false');
    if (this.productGrid) { this.productGrid.style.display = 'grid'; this.productGrid.setAttribute('aria-hidden','false'); }
    if (this.articleGrid) { this.articleGrid.style.display = 'none'; this.articleGrid.setAttribute('aria-hidden','true'); }
    this._showFilterBar(true);
    if (updateURL) this.updateURL('product');
    this._initInfiniteScrollFor('product');
    // hydrate filters in background without page overlay
    this._hydrateProductFiltersIfNeeded();
  }

  showArticles(updateURL = true) {
    this.productBtn  = this.querySelector('#productBtn') || this.productBtn;
    this.articleBtn  = this.querySelector('#articleBtn') || this.articleBtn;
    this.productGrid = this.querySelector('#collection-product') || this.productGrid;
    this.articleGrid = this.querySelector('#collection-articles') || this.articleGrid;
    this.filterBar   = this.querySelector('.filter-bar') || this.filterBar;

    this.productBtn?.classList.remove('active');
    this.productBtn?.setAttribute('aria-selected','false');
    this.articleBtn?.classList.add('active');
    this.articleBtn?.setAttribute('aria-selected','true');
    if (this.productGrid) { this.productGrid.style.display = 'none'; this.productGrid.setAttribute('aria-hidden','true'); }
    if (this.articleGrid) { this.articleGrid.style.display = 'grid'; this.articleGrid.setAttribute('aria-hidden','false'); }
    this._showFilterBar(false);
    this._initInfiniteScrollFor('article');
    if (updateURL) this.updateURL('article');
  }

  _showFilterBar(show){
    if (!this.filterBar) return;
    try { this.filterBar.style.removeProperty('display'); } catch(_) { this.filterBar.style.display = ''; }
    if (show) this.filterBar.classList.remove('filter-bar--hidden');
    else this.filterBar.classList.add('filter-bar--hidden');
    this.filterBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  async _hydrateProductFiltersIfNeeded(){
    if (this._productFiltersHydrated) return;
    const sectionId = this.dataset.id;
    if (!sectionId) return;

    // Only block UI if no products are visible at all
    const blockUI = !this.querySelector('#collection-product') ||
                    !(this.querySelector('#collection-product')?.children?.length);

    const qs = location.search.replace(/^\?/, '');
    const url = `${location.pathname}?section_id=${encodeURIComponent(sectionId)}&${qs}`;
    try {
      if (blockUI) this._showPageLoader(true);
      if (this._filtersAC) try { this._filtersAC.abort(); } catch(_) {}
      this._filtersAC = new AbortController();
      const res = await fetch(url, { signal: this._filtersAC.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newFilterSection = doc.getElementById('filterSection');
      const newFilterBar = doc.querySelector('.filter-bar');
      if (newFilterSection) {
        const currentFilterSection = this.querySelector('#filterSection');
        if (currentFilterSection) currentFilterSection.outerHTML = newFilterSection.outerHTML;
      }
      if (newFilterBar) {
        const currentFilterBar = this.querySelector('.filter-bar');
        if (currentFilterBar) currentFilterBar.outerHTML = newFilterBar.outerHTML;
        this.filterBar = this.querySelector('.filter-bar');
        this._showFilterBar(true);
      }
      this._productFiltersHydrated = true;
      document.dispatchEvent(new CustomEvent('finished:render', { bubbles: true }));
    } catch (e) {
      if (e?.name !== 'AbortError') console.warn('Failed to hydrate product filters:', e);
    } finally {
      if (blockUI) this._showPageLoader(false);
    }
  }

  _ensurePageLoader(){
    if (this._pageLoader) return this._pageLoader;
    const overlay = document.createElement('div');
    overlay.className = 'itemLoader pageLoader';
    const cloneFrom = this.querySelector('.itemLoader');
    if (cloneFrom && cloneFrom.innerHTML && cloneFrom.innerHTML.trim() !== '') {
      overlay.innerHTML = cloneFrom.innerHTML;
    } else {
      overlay.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.4 31.4"><animateTransform attributeName="transform" type="rotate" from="0 10 10" to="360 10 10" dur="1s" repeatCount="indefinite"/></circle></svg>';
    }
    document.body.appendChild(overlay);
    this._pageLoader = overlay;
    return overlay;
  }

  _showPageLoader(show){
    const el = this._ensurePageLoader();
    if (!el) return;
    if (show) el.classList.add('is-visible'); else el.classList.remove('is-visible');
  }

  updateURL(type) {
    const raw = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    if (raw.has('q')) params.set('q', raw.get('q'));
    params.set('type', type);
    if (type === 'product') {
      for (const [k,v] of raw.entries()) {
        if (k.startsWith('filter.') || k === 'page') params.set(k, v);
      }
    }
    const q = params.toString();
    const newUrl = `${location.pathname}?${q}`;
    window.history.replaceState({}, '', newUrl);
  }

  async renderSectionFromFetch(url, gridId) {
    try {
      const res  = await fetch(url);
      const html = await res.text();
      this.renderGrid(html, gridId);
      this._updateGlobalToggleCount(html, gridId);
      if (gridId === 'search__grid--articles') this._initInfiniteScrollFor('article');
      else this._initInfiniteScrollFor('product');
    } catch (err) {
      console.error('Error fetching section on main search:', err);
    }
  }

  _initInfiniteScrollFor(type){
    if (this._infScrollInstance && typeof this._infScrollInstance.destroy === 'function') {
      this._infScrollInstance.destroy();
      this._infScrollInstance = null;
    }
    if (type === 'article') {
      const container = this.querySelector('#search__grid--articles');
      const pager = this.querySelector('#infinite-scroll-articles');
      if (container && this.dataset.load) container.dataset.load = this.dataset.load;
      if (container && pager) this._infScrollInstance = new InfiniteScrollCustom('#search__grid--articles', '#infinite-scroll-articles', false);
    } else {
      const container = this.querySelector('#main-collection__grid');
      const pager = this.querySelector('#infinite-scroll-products');
      if (container && this.dataset.load) container.dataset.load = this.dataset.load;
      if (container && pager) this._infScrollInstance = new InfiniteScrollCustom('#main-collection__grid', '#infinite-scroll-products', false);
    }
  }

  _updateGlobalToggleCount(html, gridId) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (gridId === 'search__grid--articles') {
      const span = doc.getElementById('global-article-count');
      if (span && this.articleCountEl) this.articleCountEl.textContent = span.textContent;
    } else {
      const span = doc.getElementById('global-product-count');
      if (span && this.productCountEl) this.productCountEl.textContent = span.textContent;
    }
  }

  renderGrid(html, gridId) {
    const doc    = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = doc.getElementById(gridId);
    if (!newGrid) return;

    const newPager = newGrid.parentElement.querySelector('.infinite-scroll');
    const oldPager = document.getElementById(gridId)?.parentElement?.querySelector('.infinite-scroll');

    if (newPager && oldPager) {
      oldPager.dataset.page = newPager.dataset.page;
      oldPager.innerHTML    = newPager.innerHTML;
      const total = gridId === 'search__grid--articles'
        ? parseInt(this.articleCountEl?.textContent || '0')
        : parseInt(this.productCountEl?.textContent || '0');
      const currentCount = gridId === 'search__grid--articles'
        ? (this.articleGrid?.querySelectorAll('.blog-article').length || 0)
        : (this.productGrid?.querySelectorAll('.is-product').length || 0);
      if (total && currentCount >= total) oldPager.querySelector('a')?.remove();
    }

    const container = document.getElementById(gridId);
    container.innerHTML = newGrid.innerHTML;

    new RevolutionAnimation(container);
    document.dispatchEvent(new CustomEvent('finished:render', { bubbles: true }));
  }
}

customElements.define('search-component', MainSearch);


class HeadingSubheading extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
   

    this.bindEvents()
  }

  bindEvents() {

    this.delegateElement.on("click", ".heading-subheading__read-btn", this._onReadButtonClick.bind(this));
  }

  _onReadButtonClick(event) {
    event.preventDefault();
    
    const button = event.target.closest('.heading-subheading__read-btn');
    const wrapper = this.element.querySelector('.heading-subheading-text-section__wrapper');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const hiddenGroups = this.element.querySelectorAll('.group-text-button__block-wrapper:nth-child(n+3)');
    
    // Update accessibility attributes
    button.setAttribute('aria-expanded', !isExpanded);
    wrapper.setAttribute('data-expanded', !isExpanded);
    
    // Update aria-label for screen readers
    const moreText = this.element.querySelector('.more').textContent.trim();
    const lessText = this.element.querySelector('.less').textContent.trim();
    button.setAttribute('aria-label', !isExpanded ? lessText : moreText);
    
    if (!isExpanded) {
      // Expanding: Show groups with animation
      this._showGroupsWithAnimation(hiddenGroups);
    } else {
      // Collapsing: Hide groups with animation
      this._hideGroupsWithAnimation(hiddenGroups);
    }
  }

  _showGroupsWithAnimation(groups) {
    groups.forEach((group, index) => {
      // First make them visible but transparent
      group.style.display = 'block';
      group.classList.add('is-animating-in');
      
      // Trigger animation with staggered delay
      setTimeout(() => {
        group.classList.add('is-visible');
        group.classList.remove('is-animating-in');
      }, index * 100);
    });
  }

  _hideGroupsWithAnimation(groups) {
    groups.forEach((group, index) => {
      group.classList.add('is-animating-out');
      group.classList.remove('is-visible');
      
      // Listen for transition end to set display: none
      const handleTransitionEnd = (e) => {
        if (e.target === group && e.propertyName === 'opacity') {
          group.style.display = 'none';
          group.classList.remove('is-animating-out');
          group.removeEventListener('transitionend', handleTransitionEnd);
        }
      };
      
      group.addEventListener('transitionend', handleTransitionEnd);
      
      // Fallback timeout in case transitionend doesn't fire
      setTimeout(() => {
        if (group.classList.contains('is-animating-out')) {
          group.style.display = 'none';
          group.classList.remove('is-animating-out');
          group.removeEventListener('transitionend', handleTransitionEnd);
        }
      }, 400);
    });
  }

  connectedCallback() {
    // Initialize the state for SEO-enabled sections
    if (this.element.hasAttribute('data-seo-enabled')) {
      const wrapper = this.element.querySelector('.heading-subheading-text-section__wrapper');
      const button = this.element.querySelector('.heading-subheading__read-btn');
      
      if (wrapper && button) {
        wrapper.setAttribute('data-expanded', 'false');
        button.setAttribute('aria-expanded', 'false');
        
        // Set initial state for groups beyond first 2
        const hiddenGroups = this.element.querySelectorAll('.group-text-button__block-wrapper:nth-child(n+3)');
        hiddenGroups.forEach(group => {
          group.style.display = 'none';
        });
      }
    }
  }
}

customElements.define("heading-subheading", HeadingSubheading);



